// import {
//   IconChevronRight,
//   IconCloudUpload,
//   IconDownload,
//   IconPlus,
//   IconSearch,
//   IconX,
// } from "@tabler/icons-react";
// import { useEffect, useState, useMemo, Fragment } from "react";
// import RoleToggle from "../../../components/RoleToggle";
// import { useWarehouseListData } from "../../../apis/warehouseApi";
// import CreateZoneAreaModal from "./CreateZoneAreaModal";
// import CreateRowOnlyModal from "./CreateRowOnlyModel";
// import EditRowNameModal from "./EditRowNameModal";
// import CreateRowModal from "./CreateRowModal";
// import CreateFloorModal from "./CreateFloorModal";
// import ShelveBulkUploadModals from "./ShelveBulkUploadModals";
// import MessageModal from "../../../components/MessageModal";
// import FloorElement from "./FloorElement";
// import RackLevelElement from "./RackInstanceElement";
// import CreateBinsModal from "./CreateBinsModal";
// import CreatePalletModal from "./CreatePalletModal";
// import EditRackModal from "./EditRackModal";
// import Barcode from "../../../components/common/Barcode";
// import InteractiveShelvingOperatorPortal from "./InteractiveShelvingOperatorPortal";
// import { useForm } from "react-hook-form";
// import {
//   useDownloadShelveBarcode,
//   useFetchShelfAllData,
//   useFetchShelfAreaFloors,
//   useFetchShelfRowsAllData,
//   useShelfCreateMutation,
//   useShelfRowWhRowCreateMutation,
//   useShelfRowCreateMutation,
//   useShelfRowUpdateMutation,
//   useAdminRacksUpdateMutation,
//   useFetchLocationInventory,
// } from "../../../hooks/shelveHooks";
// import { useUpdateShelveStatusMutation } from "../../../apis/shelveApis";
// import toast from "react-hot-toast";

// export default function ShelveLocationTab() {
//   const [showShelveSkuModal, setShowShelveSkuModal] = useState(false);
//   const [showSearch, setShowSearch] = useState<boolean>(false);
//   const [showFilter, setShowFilter] = useState(false);
//   const toggleFilter = () => setShowFilter(!showFilter);
//   const [selectedLocation, setSelectedLocation] = useState<any>(null);
//   console.log("selectedLocation", selectedLocation);

//   const [locationArchiveConfirmModal, setLocationArchiveConfirmModal] =
//     useState<{
//       open: boolean;
//       item: any;
//       type: "bin" | "pallet";
//       action: "archive" | "restore";
//     }>({ open: false, item: null, type: "bin", action: "archive" });

//   const handleToggleLocationStatus = () => {
//     if (!selectedLocation?.item) return;
//     const isInactive = selectedLocation.item.status === "INACTIVE";
//     setLocationArchiveConfirmModal({
//       open: true,
//       item: selectedLocation.item,
//       type: selectedLocation.type,
//       action: isInactive ? "restore" : "archive",
//     });
//   };

//   const handleSelectLocation = (location: any) => {
//     setSelectedLocation(location);
//     setShowFilter(true);
//   };

//   const handleCloseFilter = () => {
//     setShowFilter(false);
//     setSelectedLocation(null);
//   };

//   // Selection states for action flow
//   const [selectedWarehouse, setSelectedWarehouse] = useState<any>(null);
//   const [selectedArea, setSelectedArea] = useState<any>(null);
//   const [selectedRow, setSelectedRow] = useState<any>(null);
//   const [selectedRack, setSelectedRack] = useState<any>(null);
//   const [selectedFloor, setSelectedFloor] = useState<any>(null);
//   const [selectedLevel, setSelectedLevel] = useState<any>(null);
//   const [levelArchiveConfirmModal, setLevelArchiveConfirmModal] = useState<{
//     open: boolean;
//     level: any;
//     action: "archive" | "restore";
//   }>({ open: false, level: null, action: "archive" });
//   const [preselectedType, setPreselectedType] = useState<
//     "bins" | "pallets" | undefined
//   >(undefined);

//   // Modal states
//   const [floorArchiveConfirmModal, setFloorArchiveConfirmModal] = useState<{
//     open: boolean;
//     floor: any;
//     action: "archive" | "restore";
//   }>({ open: false, floor: null, action: "archive" });
//   const [rowArchiveConfirmModal, setRowArchiveConfirmModal] = useState<{
//     open: boolean;
//     row: any;
//     action: "archive" | "restore";
//   }>({ open: false, row: null, action: "archive" });
//   const [rackArchiveConfirmModal, setRackArchiveConfirmModal] = useState<{
//     open: boolean;
//     rack: any;
//     action: "archive" | "restore";
//   }>({ open: false, rack: null, action: "archive" });
//   const [modal, setModal] = useState<boolean>(false);
//   const [row, setRow] = useState<boolean>(false);
//   const [rackLevelModal, setRackLevelModal] = useState<boolean>(false);
//   const [floorModal, setFloorModal] = useState<boolean>(false);
//   const [binModalOpen, setBinModalOpen] = useState(false);
//   const [palletModalOpen, setPalletModalOpen] = useState(false);
//   const [openbluk, setOpenBluk] = useState<boolean | string>(false);
//   const [openResponse, setOpenResponse] = useState<boolean | string>(false);
//   const [editRowNameModal, setEditRowNameModal] = useState<{
//     open: boolean;
//     row: any;
//   }>({ open: false, row: null });
//   const [editRackModalOpen, setEditRackModalOpen] = useState(false);

//   // Form hooks
//   const {
//     register,
//     handleSubmit,
//     clearErrors,
//     reset,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm<any>();

//   const {
//     register: editRackRegister,
//     handleSubmit: handleEditRackSubmit,
//     setValue: setEditRackValue,
//     control: editRackControl,
//     formState: { errors: editRackErrors },
//   } = useForm<any>();

//   const {
//     register: rowRegister,
//     handleSubmit: handleRowSubmit,
//     clearErrors: rowClearErrors,
//     reset: rowReset,
//     setValue: setRowValue,
//     watch: rowWatch,
//     control: rowControl,
//     formState: { errors: rowErrors },
//   } = useForm<any>({
//     defaultValues: {
//       levels: [],
//     },
//   });

//   // API hooks
//   const { data: warehouses, refetch: refetchWarehouses } =
//     useWarehouseListData();
//   const { mutate, isPending } = useShelfCreateMutation();
//   const { mutate: createRow, isPending: isCreateRowPending } =
//     useShelfRowWhRowCreateMutation();
//   const { mutate: rowMutate, isPending: isRowPending } =
//     useShelfRowCreateMutation();
//   const { mutate: updateRow, isPending: isRowUpdatePending } =
//     useShelfRowUpdateMutation(editRowNameModal.row?.id || "");
//   const archiveMutation = useUpdateShelveStatusMutation();
//   const { mutateAsync: fetchBarcode, isPending: isDownloading } =
//     useDownloadShelveBarcode();

//   // Warehouse and Area state
//   const [warehouse, setWarehouse] = useState<string>(
//     () =>
//       localStorage.getItem("WarehouseActiveRole") ||
//       warehouses?.warehouses?.[0]?.name,
//   );

//   const { data: shelves, refetch: fetchShelves } = useFetchShelfAllData(
//     warehouses?.warehouses?.find(
//       (warehouseData: any) => warehouseData?.name === warehouse,
//     )?.id,
//   );

//   const [area, setArea] = useState<string>(
//     () => localStorage.getItem("AreaActiveRole") || (shelves?.[0]?.name ?? ""),
//   );

//   const currentAreaId = shelves?.find(
//     (shelve: any) => shelve?.name === area,
//   )?.id;
//   const selectedWarehouseId = warehouses?.warehouses?.find(
//     (warehouseData: any) => warehouseData?.name === warehouse,
//   )?.id;

//   const { mutate: updateRack, isPending: isRackUpdatePending } =
//     useAdminRacksUpdateMutation(currentAreaId || "");

//   const { data: shelveRows, refetch: refetchShelveRows } =
//     useFetchShelfRowsAllData(
//       shelves?.find((shelve: any) => shelve?.name === area)?.id ?? "",
//       selectedWarehouseId,
//     );

//   const { data: floorList, refetch: refetchFloorList } =
//     useFetchShelfAreaFloors(
//       shelves?.find((shelve: any) => shelve?.name === area)?.id ?? "",
//     );

//   const { data: locationInventoryData, isLoading: isInventoryLoading } =
//     useFetchLocationInventory(selectedLocation?.item?.id ?? "");

//   const { productNames, skus, batches, expiries, serials, lots } = useMemo<{
//     productNames: string;
//     skus: string;
//     batches: string;
//     expiries: string;
//     serials: string;
//     lots: string;
//   }>(() => {
//     if (!locationInventoryData || locationInventoryData.length === 0) {
//       return {
//         productNames: "",
//         skus: "",
//         batches: "",
//         expiries: "",
//         serials: "",
//         lots: "",
//       };
//     }

//     const first = locationInventoryData[0];
//     return {
//       productNames: first.itemName || "",
//       skus: first.sku || "",
//       batches: first.batchId || "",
//       expiries: first.expiryDate || "",
//       serials: first.serialNumber || "",
//       lots: first.lotId || first.lotNumber || first.lot || "",
//     };
//   }, [locationInventoryData]);

//   const pathSegments = useMemo(() => {
//     return [
//       warehouse,
//       area,
//       selectedLocation?.row?.name,
//       selectedLocation?.floor?.name,
//       selectedLocation?.rack?.name,
//       selectedLocation?.level?.name,
//       selectedLocation?.item?.name,
//     ].filter(Boolean);
//   }, [warehouse, area, selectedLocation]);

//   const availableUnits = useMemo(() => {
//     if (!locationInventoryData) return 0;
//     return locationInventoryData.reduce(
//       (acc: number, inv: any) => acc + (inv.quantity || 0),
//       0,
//     );
//   }, [locationInventoryData]);

//   const isLocationReserved = useMemo(() => {
//     if (
//       selectedLocation?.item?.isReserved ||
//       selectedLocation?.item?.is_reserved
//     )
//       return true;
//     if (Array.isArray(locationInventoryData)) {
//       return locationInventoryData.some(
//         (inv: any) => inv.isReserved || inv.is_reserved,
//       );
//     }
//     return false;
//   }, [locationInventoryData, selectedLocation]);

//   const capacityCap = useMemo(() => {
//     if (!locationInventoryData || locationInventoryData.length === 0)
//       return null;
//     const firstItem = locationInventoryData[0];
//     const storage = firstItem?.storage || [];

//     // Resolve location type (selectedLocation?.type is "bin" or "pallet")
//     const locType = String(selectedLocation?.type || "").toLowerCase();
//     const isPallet = locType === "pallet" || locType === "pallets";

//     if (isPallet) {
//       const palletStorage = storage.find((s: any) => {
//         const t = String(s?.type || s?.storageType || "").toUpperCase();
//         return t === "PALLET" || t === "PALLETS";
//       });
//       return palletStorage ? parseInt(palletStorage.capacity) || 0 : null;
//     } else {
//       const binStorage = storage.find((s: any) => {
//         const t = String(s?.type || s?.storageType || "").toUpperCase();
//         return t === "BIN" || t === "BINS";
//       });
//       return binStorage ? parseInt(binStorage.capacity) || 0 : null;
//     }
//   }, [locationInventoryData, selectedLocation]);

//   const hasActiveInventory = useMemo(() => {
//     if (availableUnits > 0) return true;
//     const item = selectedLocation?.item;
//     if (item?.currentInventoryCount && item.currentInventoryCount > 0)
//       return true;
//     if (item?.current_inventory_count && item.current_inventory_count > 0)
//       return true;
//     return false;
//   }, [availableUnits, selectedLocation]);

//   // Effects
//   useEffect(() => {
//     localStorage.setItem("WarehouseActiveRole", warehouse);
//     const warehouseObj = warehouses?.warehouses?.find(
//       (w: any) => w?.name === warehouse,
//     );
//     setSelectedWarehouse(warehouseObj);
//     setSelectedArea(null);
//     setSelectedRow(null);
//     setSelectedRack(null);
//     setSelectedFloor(null);
//     setSelectedLevel(null);
//   }, [warehouse, warehouses]);

//   useEffect(() => {
//     localStorage.setItem("AreaActiveRole", area);
//     const areaObj = shelves?.find((s: any) => s?.name === area);
//     setSelectedArea(areaObj);
//     setSelectedRow(null);
//     setSelectedRack(null);
//     setSelectedFloor(null);
//     setSelectedLevel(null);
//   }, [area, shelves]);

//   useEffect(() => {
//     if (selectedRow) {
//       setSelectedRack(null);
//       setSelectedFloor(null);
//       setSelectedLevel(null);
//       setModal(false);
//       setRow(false);
//       setRackLevelModal(false);
//       setFloorModal(false);
//       setEditRackModalOpen(false);
//     }
//   }, [selectedRow]);

//   useEffect(() => {
//     if (selectedFloor) {
//       setSelectedRow(null);
//       setSelectedRack(null);
//       setSelectedLevel(null);
//       setModal(false);
//       setRow(false);
//       setRackLevelModal(false);
//       setFloorModal(false);
//       setEditRackModalOpen(false);
//     }
//   }, [selectedFloor]);

//   useEffect(() => {
//     if (selectedRack) {
//       setSelectedRow(null);
//       setSelectedFloor(null);
//       setSelectedLevel(null);
//       setModal(false);
//       setRow(false);
//       setRackLevelModal(false);
//       setFloorModal(false);
//       setEditRackModalOpen(false);
//     }
//   }, [selectedRack]);

//   useEffect(() => {
//     if (selectedLevel) {
//       setSelectedRow(null);
//       setSelectedFloor(null);
//       setSelectedRack(null);
//       setModal(false);
//       setRow(false);
//       setRackLevelModal(false);
//       setFloorModal(false);
//       setEditRackModalOpen(false);
//     }
//   }, [selectedLevel]);

//   const selectedLevelParentRack = useMemo(() => {
//     if (!selectedLevel || !shelveRows) return null;
//     return shelveRows
//       .flatMap((row: any) => row.rack || [])
//       .find((rack: any) =>
//         rack.level?.some((lvl: any) => lvl.id === selectedLevel.id),
//       );
//   }, [selectedLevel, shelveRows]);

//   const selectedLevelParentRow = useMemo(() => {
//     if (!selectedLevel || !shelveRows) return null;
//     return shelveRows.find((row: any) =>
//       row.rack?.some((rack: any) =>
//         rack.level?.some((lvl: any) => lvl.id === selectedLevel.id),
//       ),
//     );
//   }, [selectedLevel, shelveRows]);

//   const selectedRackParentRow = useMemo(() => {
//     if (!selectedRack || !shelveRows) return null;
//     return shelveRows.find((row: any) =>
//       row.rack?.some((rack: any) => rack.id === selectedRack.id),
//     );
//   }, [selectedRack, shelveRows]);

//   const editRackDefaultValues = useMemo(
//     () => ({
//       name: selectedRack?.name,
//       levels: selectedRack?.level,
//     }),
//     [selectedRack],
//   );

//   const getFloorsByRow = (floors: any[], rows: any[]) => {
//     const mappedFloors: { [key: string]: any[] } = {};
//     rows.forEach((row) => {
//       mappedFloors[row.id] = [];
//     });
//     floors.forEach((floor) => {
//       const rackId = floor.whRackId || floor.wh_rack_id;
//       if (rackId) return;

//       const afterRowId = floor.after_wh_row_id;
//       if (afterRowId && mappedFloors[afterRowId]) {
//         mappedFloors[afterRowId].push(floor);
//       } else {
//         if (!mappedFloors["last_row"]) {
//           mappedFloors["last_row"] = [];
//         }
//         mappedFloors["last_row"].push(floor);
//       }
//     });
//     return mappedFloors;
//   };

//   // Group rack-nested floors by rack ID
//   // Note: API returns snake_case (wh_rack_id) due to Sequelize underscored:true
//   const getFloorsByRack = (floors: any[]) => {
//     const byRack: { [rackId: string]: { start: any[]; end: any[] } } = {};
//     floors.forEach((floor) => {
//       // Support both camelCase and snake_case field names from API response
//       const rackId = floor.whRackId || floor.wh_rack_id;
//       if (!rackId) return;
//       if (!byRack[rackId]) {
//         byRack[rackId] = { start: [], end: [] };
//       }
//       if (floor.position?.toLowerCase() === "end") {
//         byRack[rackId].end.push(floor);
//       } else {
//         // Default to start if position is "Start" or not set
//         byRack[rackId].start.push(floor);
//       }
//     });
//     return byRack;
//   };

//   const floorsByRow = useMemo(
//     () => getFloorsByRow(floorList || [], shelveRows || []),
//     [floorList, shelveRows],
//   );

//   const floorsByRack = useMemo(
//     () => getFloorsByRack(floorList || []),
//     [floorList],
//   );

//   const selectedFloorParentRow = useMemo(() => {
//     if (!selectedFloor || !shelveRows) return null;
//     return shelveRows.find(
//       (row: any) =>
//         floorsByRow[row.id]?.some((f: any) => f.id === selectedFloor.id) ||
//         row.rack?.some(
//           (rack: any) =>
//             floorsByRack[rack.id]?.start?.some(
//               (f: any) => f.id === selectedFloor.id,
//             ) ||
//             floorsByRack[rack.id]?.end?.some(
//               (f: any) => f.id === selectedFloor.id,
//             ),
//         ),
//     );
//   }, [selectedFloor, shelveRows, floorsByRow, floorsByRack]);

//   const selectedFloorParentRack = useMemo(() => {
//     if (!selectedFloor || !shelveRows) return null;
//     return shelveRows
//       .flatMap((row: any) => row.rack || [])
//       .find(
//         (rack: any) =>
//           floorsByRack[rack.id]?.start?.some(
//             (f: any) => f.id === selectedFloor.id,
//           ) ||
//           floorsByRack[rack.id]?.end?.some(
//             (f: any) => f.id === selectedFloor.id,
//           ),
//       );
//   }, [selectedFloor, shelveRows, floorsByRack]);

//   const getFloorInventory = (floor: any): number => {
//     if (!floor || !floor.pallet) return 0;
//     return floor.pallet.reduce(
//       (sum: number, p: any) => sum + (p.currentInventoryCount || 0),
//       0,
//     );
//   };

//   const getLevelInventory = (level: any): number => {
//     if (!level) return 0;
//     const binSum = (level.bin || []).reduce(
//       (sum: number, b: any) => sum + (b.currentInventoryCount || 0),
//       0,
//     );
//     const palletSum = (level.pallet || []).reduce(
//       (sum: number, p: any) => sum + (p.currentInventoryCount || 0),
//       0,
//     );
//     return binSum + palletSum;
//   };

//   const getRackInventory = (rack: any): number => {
//     if (!rack || !rack.level) return 0;
//     return rack.level.reduce(
//       (sum: number, lvl: any) => sum + getLevelInventory(lvl),
//       0,
//     );
//   };

//   const getRowInventory = (row: any): number => {
//     if (!row) return 0;
//     const racksSum = (row.rack || []).reduce(
//       (sum: number, r: any) => sum + getRackInventory(r),
//       0,
//     );
//     let floorsSum = 0;
//     const rowFloors = floorsByRow[row.id] || [];
//     floorsSum += rowFloors.reduce(
//       (sum: number, f: any) => sum + getFloorInventory(f),
//       0,
//     );
//     (row.rack || []).forEach((rack: any) => {
//       const startFloors = floorsByRack[rack.id]?.start || [];
//       const endFloors = floorsByRack[rack.id]?.end || [];
//       floorsSum += startFloors.reduce(
//         (sum: number, f: any) => sum + getFloorInventory(f),
//         0,
//       );
//       floorsSum += endFloors.reduce(
//         (sum: number, f: any) => sum + getFloorInventory(f),
//         0,
//       );
//     });
//     return racksSum + floorsSum;
//   };

//   // Handlers
//   const handleCreateShelve = (formData: any) => {
//     const payload = {
//       warehouseId: selectedWarehouseId,
//       ...formData,
//     };
//     mutate(payload, {
//       onSuccess: () => {
//         setModal(false);
//         fetchShelves();
//         setArea(shelves?.[0]?.name ?? "");
//       },
//       onError: (error) => toast.error(`${error}`),
//     });
//   };

//   const handleCreateRow = (formData: any) => {
//     if (!selectedWarehouseId || !currentAreaId) {
//       toast.error("Warehouse and Area must be selected");
//       return;
//     }

//     createRow(
//       {
//         name: formData.name,
//         rowNumbers: formData.rowNumbers,
//         warehouseId: selectedWarehouseId,
//         whAreaId: currentAreaId,
//       },
//       {
//         onSuccess: () => {
//           setRow(false);
//           refetchShelveRows();
//           refetchFloorList();
//           rowReset();
//           toast.success("Row created successfully");
//         },
//         onError: (error: any) => {
//           toast.error(`Failed to create row: ${error.message}`);
//         },
//       },
//     );
//   };

//   const handleCreateRackLevel = (formData: any) => {
//     if (!selectedRow) {
//       toast.error("Please select a row first");
//       return;
//     }

//     const storageType =
//       formData.storageType ||
//       (selectedArea?.storageType === "B2C" ? "Shelves" : "Bins");

//     const payload = {
//       ...formData,
//       whAreaId: currentAreaId,
//       whRowId: selectedRow.id,
//       storageType,
//     };

//     rowMutate(payload, {
//       onSuccess: () => {
//         toast.success("Rack/Level created successfully");
//         setRackLevelModal(false);
//         rowReset();
//         refetchShelveRows();
//         refetchFloorList();
//       },
//       onError: (error) => toast.error(`${error}`),
//     });
//   };

//   const handleEditRack = (formData: any) => {
//     const parentRow = selectedRow || selectedRackParentRow;
//     if (!selectedRack || !parentRow) {
//       toast.error("Rack and parent Row must be determined");
//       return;
//     }
//     const payload = {
//       whAreaId: currentAreaId,
//       whRowId: parentRow.id,
//       whRackId: selectedRack.id,
//       name: formData.rackName || selectedRack.name,
//       levels:
//         formData.levels?.map((level: any, index: number) => ({
//           id: selectedRack.level?.[index]?.id || level.id,
//           name: level.name || selectedRack.level?.[index]?.name,
//           levelNumber:
//             level.levelNumber ||
//             selectedRack.level?.[index]?.levelNumber ||
//             index + 1,
//         })) ||
//         selectedRack.level ||
//         [],
//     };

//     updateRack(payload, {
//       onSuccess: () => {
//         toast.success("Rack updated successfully");
//         setEditRackModalOpen(false);
//         refetchShelveRows();
//         refetchFloorList();
//       },
//       onError: (error: any) => toast.error(`${error}`),
//     });
//   };

//   const handleDownload = async () => {
//     if (!selectedWarehouseId || !currentAreaId) {
//       toast.error("Please select a valid Warehouse and Area");
//       return;
//     }

//     const res = await fetchBarcode({
//       warehouseId: selectedWarehouseId,
//       shelveId: currentAreaId,
//     });
//     if (res?.pdfUrl) {
//       window.open(res.pdfUrl, "_blank");
//     } else {
//       toast.error("Failed to download barcode PDF");
//     }
//   };

//   // Determine which action buttons are enabled
//   const isCreateAreaEnabled = !!selectedWarehouse;
//   const isCreateRowEnabled = !!selectedArea;
//   const isRackLevelEnabled = !!selectedRow && selectedRow.status !== "INACTIVE";

//   const rowFloors = selectedRow ? floorsByRow[selectedRow.id] || [] : [];
//   const racks = selectedRow ? selectedRow.rack || [] : [];

//   const rowFloorBlocked = selectedRow
//     ? rowFloors.length > 0 ||
//       (() => {
//         const firstRack = racks[0];
//         return firstRack
//           ? (floorsByRack[firstRack.id]?.start?.length ?? 0) > 0
//           : false;
//       })()
//     : false;

//   const anyValidRackSlot = selectedRow
//     ? racks.some((rack: any, index: number) => {
//         const startBlocked =
//           (floorsByRack[rack.id]?.start?.length ?? 0) > 0 ||
//           (() => {
//             if (index === 0) {
//               return rowFloors.length > 0;
//             } else {
//               const prevRack = racks[index - 1];
//               return (floorsByRack[prevRack.id]?.end?.length ?? 0) > 0;
//             }
//           })();

//         const endBlocked =
//           (floorsByRack[rack.id]?.end?.length ?? 0) > 0 ||
//           (() => {
//             if (index < racks.length - 1) {
//               const nextRack = racks[index + 1];
//               return (floorsByRack[nextRack.id]?.start?.length ?? 0) > 0;
//             }
//             return false;
//           })();

//         return !startBlocked || !endBlocked;
//       })
//     : false;

//   const isFloorEnabled =
//     !!selectedRow && (!rowFloorBlocked || anyValidRackSlot);

//   return (
//     <div className="pb-6">
//       {/* Header Section - Enhanced */}
//       <div className="rounded-[28px] border border-slate-200 bg-white shadow-sm overflow-hidden mt-6 transition-all duration-300 hover:shadow-md">
//         <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 p-4 bg-gradient-to-r from-white to-slate-50/50">
//           <div className="flex items-center space-x-4 overflow-x-auto scrollbar-hide whitespace-nowrap py-1">
//             <RoleToggle
//               containerClassName="space-x-2 w-[500px] pb-2"
//               inactiveClassName="bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors"
//               options={
//                 warehouses?.warehouses?.length > 0
//                   ? warehouses?.warehouses?.map(
//                       (warehouse: any) => warehouse?.name,
//                     )
//                   : []
//               }
//               active={warehouse}
//               onChange={(value) => {
//                 setWarehouse(value);
//                 setArea("");
//               }}
//             />
//           </div>

//           <div className="flex items-center flex-wrap gap-2.5">
//             {/* Enhanced Search with Keyboard Shortcut */}
//             <div
//               onClick={() => {
//                 if (!showSearch) {
//                   setShowSearch(true);
//                 }
//               }}
//               className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${
//                 showSearch
//                   ? "w-64 px-2 cursor-default ring-2 ring-blue-400/20 border-blue-300"
//                   : "w-8 justify-center cursor-pointer hover:border-blue-400 hover:shadow-md"
//               }`}
//             >
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setShowSearch(!showSearch);
//                 }}
//                 className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0 hover:text-blue-600 transition-colors"
//                 title="Search (Ctrl+K)"
//               >
//                 <IconSearch size={17} stroke={2.5} />
//               </button>
//               {showSearch && (
//                 <>
//                   <input
//                     type="text"
//                     placeholder="Search locations, products..."
//                     autoFocus
//                     className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
//                     onKeyDown={(e) => {
//                       if (e.key === "Escape") setShowSearch(false);
//                     }}
//                   />
//                   <span className="text-[10px] text-slate-400 font-mono px-1">
//                     ⌘K
//                   </span>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setShowSearch(false);
//                     }}
//                     className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded focus:outline-none flex-shrink-0 transition-colors"
//                     title="Clear & Close"
//                   >
//                     <IconX size={14} stroke={2.5} />
//                   </button>
//                 </>
//               )}
//             </div>

//             {/* Action Buttons with Tooltips */}
//             <div className="flex items-center gap-1.5">
//               <button
//                 onClick={() => setShowShelveSkuModal(true)}
//                 className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-blue-400 hover:text-blue-600 transition-all duration-200 group relative"
//                 title="Add New Location"
//               >
//                 <IconPlus stroke={2.5} size={17} />
//                 <span className="absolute top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
//                   Add Location
//                 </span>
//               </button>
//               <button
//                 onClick={() => setOpenBluk(true)}
//                 className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-emerald-400 hover:text-emerald-600 transition-all duration-200 group relative"
//                 title="Bulk Upload"
//               >
//                 <IconCloudUpload stroke={2.5} size={17} />
//                 <span className="absolute top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
//                   Bulk Upload
//                 </span>
//               </button>
//               <button
//                 onClick={handleDownload}
//                 className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-purple-400 hover:text-purple-600 transition-all duration-200 group relative"
//                 title="Export Data"
//               >
//                 <IconDownload stroke={2.5} size={17} />
//                 <span className="absolute top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
//                   Export Data
//                 </span>
//               </button>
//             </div>

//             {/* Enhanced Stats Dashboard */}
//             <div className="flex items-center gap-2 px-3 py-1 bg-gradient-to-r from-blue-50/80 to-indigo-50/80 border border-blue-100 rounded-md shadow-sm select-none hover:shadow-md transition-shadow">
//               <div className="flex items-center gap-3">
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-slate-500 text-[11px] font-medium">
//                     Total
//                   </span>
//                   <span className="text-blue-700 bg-blue-50 border border-blue-100 px-2 py-0.5 rounded-md text-xs font-bold">
//                     5
//                   </span>
//                 </div>
//                 <div className="h-5 w-px bg-blue-200" />
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-slate-500 text-[11px] font-medium">
//                     Connected
//                   </span>
//                   <span className="text-emerald-700 bg-emerald-50 border border-emerald-100 px-2 py-0.5 rounded-md text-xs font-bold flex items-center gap-1">
//                     <span className="relative flex h-1.5 w-1.5">
//                       <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
//                       <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500"></span>
//                     </span>
//                     2
//                   </span>
//                 </div>
//                 <div className="h-5 w-px bg-blue-200" />
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-slate-500 text-[11px] font-medium">
//                     Request
//                   </span>
//                   <span className="text-amber-700 bg-amber-50 border border-amber-100 px-2 py-0.5 rounded-md text-xs font-bold flex items-center gap-1">
//                     <span className="animate-pulse">⏳</span>2
//                   </span>
//                 </div>
//                 <div className="h-5 w-px bg-blue-200" />
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-slate-500 text-[11px] font-medium">
//                     Connect
//                   </span>
//                   <span className="text-sky-700 bg-sky-50 border border-sky-100 px-2 py-0.5 rounded-md text-xs font-bold">
//                     1
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Enhanced Search and Area Toggle */}
//         <div className="flex items-center justify-between px-5 py-4 border-t bg-white/50">
//           <div className="w-full max-w-md flex items-center gap-3">
//             {/* Quick Filter Chips */}
//             <div className="flex items-center gap-1.5 overflow-x-auto scrollbar-hide">
//               {["All", "Active", "Archived", "Full", "Empty"].map((filter) => (
//                 <button
//                   key={filter}
//                   className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
//                     filter === "All"
//                       ? "bg-[#081229] text-white shadow-sm"
//                       : "bg-slate-100 text-slate-600 hover:bg-slate-200"
//                   }`}
//                 >
//                   {filter}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             {["Heatmap", "Inventory"].map((item, index) => (
//               <button
//                 key={item}
//                 className={`text-sm font-medium transition-all duration-200 ${
//                   index === 0
//                     ? "rounded-full bg-[#081229] px-4 py-2 text-white shadow-md hover:shadow-lg transform hover:scale-105"
//                     : "text-slate-700 hover:text-slate-900 hover:bg-slate-100 px-3 py-2 rounded-full"
//                 }`}
//               >
//                 {item}
//                 {index === 0 && (
//                   <span className="ml-2 text-[10px] bg-white/20 px-1.5 py-0.5 rounded-full">
//                     Beta
//                   </span>
//                 )}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div
//         className={`mt-6 grid gap-6 ${showShelveSkuModal ? "xl:grid-cols-[minmax(0,1fr)_40%]" : "xl:grid-cols-[minmax(0,1fr)_320px]"}`}
//       >
//         {/* Enhanced Warehouse Map Section */}
//         <div className="rounded-3xl border border-slate-200 shadow-sm bg-[repeating-linear-gradient(45deg,_rgb(248,250,252),_rgb(248,250,252)_10px,_rgb(255,255,255)_10px,_rgb(255,255,255)_20px)] hover:shadow-md transition-shadow">
//           <div className="flex flex-col gap-3 rounded-t-3xl p-4 bg-white border-b">
//             <div className="flex items-start justify-between">
//               <div>
//                 <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2">
//                   <span>🏗️ Interactive Warehouse Map</span>
//                   <span className="text-xs font-normal text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">
//                     Drag to explore
//                   </span>
//                 </h3>
//                 <p className="text-sm text-slate-500">
//                   Click any bin, pallet, floor location, shipment level, QC bin
//                   or damaged lane.
//                 </p>
//               </div>
//               {/* Mini Map Legend */}
//               <div className="flex items-center gap-3 text-[10px] text-slate-500">
//                 <div className="flex items-center gap-1">
//                   <span className="w-3 h-3 rounded bg-yellow-400 border border-yellow-300"></span>
//                   <span>Active</span>
//                 </div>
//                 <div className="flex items-center gap-1">
//                   <span className="w-3 h-3 rounded bg-gray-300 border border-gray-400"></span>
//                   <span>Archived</span>
//                 </div>
//                 <div className="flex items-center gap-1">
//                   <span className="w-3 h-3 rounded bg-emerald-400 border border-emerald-300"></span>
//                   <span>Occupied</span>
//                 </div>
//               </div>
//             </div>
//             <div className="flex flex-wrap gap-2 text-xs font-medium">
//               {shelves?.map((shelf: any) => (
//                 <button
//                   key={shelf.id}
//                   onClick={() => {
//                     setArea(shelf.name);
//                     setSelectedRow(null);
//                     setSelectedRack(null);
//                   }}
//                   className={`rounded-full px-3 py-1.5 transition-all duration-200 ${
//                     area === shelf.name
//                       ? "bg-[#FBD037] text-[#212121] shadow-md transform scale-105"
//                       : "bg-slate-100 text-slate-600 hover:bg-slate-200 hover:scale-105"
//                   }`}
//                 >
//                   {shelf.name}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Enhanced Shelves/Rows Display with Virtual Scroll */}
//           {!shelves || shelves.length === 0 ? (
//             <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn">
//               <img
//                 src="/img/scan-data.png"
//                 alt="scan prompt"
//                 className="w-48 opacity-80"
//               />
//               <div className="text-center max-w-sm">
//                 <h2 className="text-[#212121] text-lg font-medium">
//                   🚀 Create Zone & Area
//                 </h2>
//                 <p className="text-[#212121]/70 text-sm mt-1">
//                   You don't have any Area yet. Create one using the button
//                   above.
//                 </p>
//               </div>
//               <button
//                 onClick={() => setModal(true)}
//                 className="flex items-center gap-2 py-2.5 px-6 text-sm rounded-full text-[#212121] bg-[#FBD037] font-medium hover:bg-yellow-400 transition transform hover:scale-105 shadow-md hover:shadow-lg"
//               >
//                 <IconPlus stroke={1.5} size={20} /> Create Area
//               </button>
//             </div>
//           ) : shelveRows?.length === 0 ? (
//             <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn">
//               <img
//                 src="/img/scan-data.png"
//                 alt="scan prompt"
//                 className="w-48 opacity-80"
//               />
//               <div className="text-center max-w-sm">
//                 <h2 className="text-[#212121] text-lg font-medium">
//                   📦 Add Rows
//                 </h2>
//                 <p className="text-[#212121]/70 text-sm mt-1">
//                   You don't have any Row yet. Create one using the button above.
//                 </p>
//               </div>
//               <button
//                 onClick={() => {
//                   setRow(true);
//                 }}
//                 className="flex items-center gap-2 py-2.5 px-6 text-sm rounded-full text-[#212121] bg-[#FBD037] font-medium hover:bg-yellow-400 transition transform hover:scale-105 shadow-md hover:shadow-lg"
//               >
//                 <IconPlus stroke={1.5} size={20} /> Create Row
//               </button>
//             </div>
//           ) : (
//             <div className="flex flex-row gap-4 overflow-x-auto overflow-y-auto min-h-[400px] p-4 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent">
//               {(() => {
//                 const items: Array<{
//                   type: "row" | "floor";
//                   data: any;
//                   key: string;
//                 }> = [];

//                 shelveRows?.forEach((row: any) => {
//                   items.push({ type: "row", data: row, key: `row-${row.id}` });
//                 });

//                 if (
//                   floorsByRow["last_row"] &&
//                   floorsByRow["last_row"].length > 0
//                 ) {
//                   floorsByRow["last_row"].forEach((floor: any) => {
//                     items.push({
//                       type: "floor",
//                       data: floor,
//                       key: `floor-last-${floor.id}`,
//                     });
//                   });
//                 }

//                 return items.map((item) => {
//                   if (item.type === "row") {
//                     const row = item.data;
//                     return (
//                       <div
//                         key={item.key}
//                         onClick={() => {
//                           setSelectedRow(row);
//                           setSelectedRack(null);
//                         }}
//                         className={`w-56 shrink-0 rounded-2xl border p-3 cursor-pointer transition-all duration-300 ${
//                           row.status === "INACTIVE"
//                             ? "opacity-50 grayscale"
//                             : "hover:shadow-xl hover:-translate-y-1"
//                         } ${
//                           selectedRow?.id === row.id
//                             ? "border-[#FBD037] bg-yellow-50 shadow-lg ring-2 ring-yellow-300/50"
//                             : "border-slate-200 bg-white hover:shadow-md"
//                         }`}
//                       >
//                         <div className="mb-3 border-b border-slate-200 pb-3">
//                           <div className="flex justify-between items-center">
//                             <div className="text-sm font-semibold text-slate-900 flex items-center gap-2">
//                               {row.name}
//                               <span className="text-[10px] text-slate-400 font-normal">
//                                 #{row.id?.slice(0, 6)}
//                               </span>
//                             </div>
//                             {row.status === "INACTIVE" && (
//                               <span className="px-2 py-0.5 rounded text-[9px] font-bold uppercase bg-gray-200 text-gray-600 flex items-center gap-1">
//                                 <span className="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
//                                 Archived
//                               </span>
//                             )}
//                           </div>
//                           <div className="text-xs text-slate-500">Rack Row</div>
//                           {/* Row Stats */}
//                           <div className="flex gap-2 mt-1 text-[10px]">
//                             <span className="bg-slate-100 px-1.5 py-0.5 rounded">
//                               🏷️ {row.rack?.length || 0} Racks
//                             </span>
//                             <span className="bg-slate-100 px-1.5 py-0.5 rounded">
//                               📦 {getRowInventory(row)} Items
//                             </span>
//                           </div>
//                         </div>

//                         <div className="space-y-3 max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
//                           {floorsByRow[row.id]?.map((floor: any) => (
//                             <div key={`rowfloor-${floor.id}`}>
//                               <FloorElement
//                                 floorId={floor.id}
//                                 floorName={floor.name}
//                                 floor={floor}
//                                 slots={floor.pallet || []}
//                                 fetchShelves={() => {
//                                   refetchFloorList();
//                                   refetchShelveRows();
//                                 }}
//                                 warehouseId={selectedWarehouseId}
//                                 clientId={selectedWarehouse?.clientId}
//                                 areaId={currentAreaId}
//                                 isParentRowArchived={row.status === "INACTIVE"}
//                                 onClick={() => setSelectedFloor(floor)}
//                                 isSelected={selectedFloor?.id === floor.id}
//                                 onPalletClick={(pallet) =>
//                                   handleSelectLocation({
//                                     item: pallet,
//                                     type: "pallet",
//                                     row,
//                                     floor,
//                                   })
//                                 }
//                               />
//                             </div>
//                           ))}
//                           {row.rack?.map((rack: any, rackIndex: number) => (
//                             <Fragment key={rack.id}>
//                               {floorsByRack[rack.id]?.start?.map(
//                                 (floor: any) => (
//                                   <div
//                                     key={`rackfloor-start-${floor.id}`}
//                                     className="mb-2"
//                                   >
//                                     <FloorElement
//                                       floorId={floor.id}
//                                       floorName={floor.name}
//                                       floor={floor}
//                                       slots={floor.pallet || []}
//                                       fetchShelves={() => {
//                                         refetchFloorList();
//                                         refetchShelveRows();
//                                       }}
//                                       warehouseId={selectedWarehouseId}
//                                       clientId={selectedWarehouse?.clientId}
//                                       areaId={currentAreaId}
//                                       isParentRowArchived={
//                                         row.status === "INACTIVE"
//                                       }
//                                       onClick={() => setSelectedFloor(floor)}
//                                       isSelected={
//                                         selectedFloor?.id === floor.id
//                                       }
//                                       onPalletClick={(pallet) =>
//                                         handleSelectLocation({
//                                           item: pallet,
//                                           type: "pallet",
//                                           row,
//                                           rack,
//                                           floor,
//                                         })
//                                       }
//                                     />
//                                   </div>
//                                 ),
//                               )}

//                               {/* Enhanced Rack card */}
//                               <div
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setSelectedRack(rack);
//                                 }}
//                                 className={`rounded-2xl border border-dashed p-3 cursor-pointer transition-all duration-300 ${
//                                   rack.status === "INACTIVE"
//                                     ? "opacity-50 grayscale"
//                                     : "hover:shadow-md"
//                                 } ${
//                                   selectedRack?.id === rack.id
//                                     ? "bg-yellow-50 border-yellow-300 ring-2 ring-yellow-300/30"
//                                     : "bg-slate-50 border-slate-200 hover:bg-slate-100"
//                                 }`}
//                               >
//                                 <div className="flex justify-between items-center mb-2">
//                                   <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 flex items-center gap-1.5">
//                                     {rack.name}
//                                     <span className="text-[8px] text-slate-300 font-normal">
//                                       #{rack.id?.slice(0, 4)}
//                                     </span>
//                                   </div>
//                                   {rack.status === "INACTIVE" && (
//                                     <span className="px-2 py-0.5 rounded text-[9px] font-bold uppercase bg-gray-200 text-gray-600">
//                                       Archived
//                                     </span>
//                                   )}
//                                 </div>
//                                 {rack.level && rack.level.length > 0 ? (
//                                   <div className="flex flex-col gap-3">
//                                     {rack.level.map(
//                                       (level: any, idx: number) => (
//                                         <div
//                                           key={level.id}
//                                           className="relative"
//                                         >
//                                           {/* Level Indicator */}
//                                           <div className="absolute -left-2 top-1/2 -translate-y-1/2 w-1 h-6 bg-gradient-to-b from-blue-400 to-purple-400 rounded-full opacity-50"></div>
//                                           <RackLevelElement
//                                             key={level.id}
//                                             rackLevelId={level.id}
//                                             rackLevelName={level.name}
//                                             rackLevel={level}
//                                             pallets={level.pallet || []}
//                                             bins={level.bin || []}
//                                             fetchShelves={() => {
//                                               refetchShelveRows();
//                                               refetchFloorList();
//                                             }}
//                                             isParentRowArchived={
//                                               row.status === "INACTIVE" ||
//                                               rack.status === "INACTIVE"
//                                             }
//                                             onItemClick={(item, type) =>
//                                               handleSelectLocation({
//                                                 item,
//                                                 type,
//                                                 row,
//                                                 rack,
//                                                 level,
//                                               })
//                                             }
//                                             onClick={() =>
//                                               setSelectedLevel(level)
//                                             }
//                                             isSelected={
//                                               selectedLevel?.id === level.id
//                                             }
//                                           />
//                                           {/* Level Divider */}
//                                           {idx < rack.level.length - 1 && (
//                                             <div className="w-full h-px bg-slate-200 my-1"></div>
//                                           )}
//                                         </div>
//                                       ),
//                                     )}
//                                   </div>
//                                 ) : (
//                                   <div className="rounded-xl border border-dashed border-slate-200 px-3 py-6 text-center text-xs text-slate-400 hover:border-slate-300 transition-colors">
//                                     <span className="block text-2xl mb-1">
//                                       📋
//                                     </span>
//                                     No levels configured
//                                   </div>
//                                 )}
//                               </div>

//                               {floorsByRack[rack.id]?.end?.map((floor: any) => (
//                                 <div
//                                   key={`rackfloor-end-${floor.id}`}
//                                   className="mt-2"
//                                 >
//                                   <FloorElement
//                                     floorId={floor.id}
//                                     floorName={floor.name}
//                                     floor={floor}
//                                     slots={floor.pallet || []}
//                                     fetchShelves={() => {
//                                       refetchFloorList();
//                                       refetchShelveRows();
//                                     }}
//                                     warehouseId={selectedWarehouseId}
//                                     clientId={selectedWarehouse?.clientId}
//                                     areaId={currentAreaId}
//                                     isParentRowArchived={
//                                       row.status === "INACTIVE"
//                                     }
//                                     onClick={() => setSelectedFloor(floor)}
//                                     isSelected={selectedFloor?.id === floor.id}
//                                     onPalletClick={(pallet) =>
//                                       handleSelectLocation({
//                                         item: pallet,
//                                         type: "pallet",
//                                         row,
//                                         rack,
//                                         floor,
//                                       })
//                                     }
//                                   />
//                                 </div>
//                               ))}
//                             </Fragment>
//                           ))}
//                         </div>
//                       </div>
//                     );
//                   } else {
//                     const floor = item.data;
//                     return (
//                       <div key={item.key} className="w-56 shrink-0">
//                         <FloorElement
//                           floorId={floor.id}
//                           floorName={floor.name}
//                           floor={floor}
//                           slots={floor.pallet || []}
//                           fetchShelves={() => {
//                             refetchFloorList();
//                             refetchShelveRows();
//                           }}
//                           warehouseId={selectedWarehouseId}
//                           clientId={selectedWarehouse?.clientId}
//                           areaId={currentAreaId}
//                           onClick={() => setSelectedFloor(floor)}
//                           isSelected={selectedFloor?.id === floor.id}
//                           onPalletClick={(pallet) =>
//                             handleSelectLocation({
//                               item: pallet,
//                               type: "pallet",
//                               floor,
//                             })
//                           }
//                         />
//                       </div>
//                     );
//                   }
//                 });
//               })()}
//             </div>
//           )}
//         </div>

//         {/* Enhanced Side Panel */}
//         <div className="space-y-4">
//           {showShelveSkuModal ? (         
//             <InteractiveShelvingOperatorPortal
//               onClose={() => setShowShelveSkuModal(false)}
//               warehouseId={selectedWarehouseId}
//               onSuccess={() => {
//                 refetchFloorList();
//                 refetchShelveRows();
//               }}
//             />
//           ) : (
//             <div className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md transition-shadow">
//               <div className="mb-3 flex items-center justify-between">
//                 <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-2">
//                   <span>⚡</span> Operational Quick Actions
//                 </h3>
//                 <span className="rounded-full bg-gradient-to-r from-blue-50 to-indigo-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-blue-700 border border-blue-100">
//                   {selectedRow ? `Active: ${selectedRow.name}` : "Actions"}
//                 </span>
//               </div>

//               {/* Enhanced Action Grid */}
//               <div className="grid grid-cols-2 gap-2">
//                 <button
//                   onClick={() => {
//                     setModal(true);
//                     setRow(false);
//                     setRackLevelModal(false);
//                     setFloorModal(false);
//                     setEditRackModalOpen(false);
//                     rowReset();
//                   }}
//                   disabled={!isCreateAreaEnabled}
//                   className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
//                     isCreateAreaEnabled
//                       ? "bg-[#212121] text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
//                       : "bg-gray-200 text-gray-500 cursor-not-allowed"
//                   }`}
//                 >
//                   <span className="flex items-center justify-center gap-1.5">
//                     <span>🏗️</span> Create Area
//                   </span>
//                 </button>

//                 <button
//                   onClick={() => {
//                     setRow(true);
//                     setModal(false);
//                     setRackLevelModal(false);
//                     setFloorModal(false);
//                     setEditRackModalOpen(false);
//                     rowReset();
//                   }}
//                   disabled={!isCreateRowEnabled}
//                   className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
//                     isCreateRowEnabled
//                       ? "bg-[#212121] text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
//                       : "bg-gray-200 text-gray-500 cursor-not-allowed"
//                   }`}
//                 >
//                   <span className="flex items-center justify-center gap-1.5">
//                     <span>📋</span> Create Row
//                   </span>
//                 </button>

//                 <button
//                   onClick={() => {
//                     if (selectedRow) {
//                       setRackLevelModal(true);
//                       setModal(false);
//                       setRow(false);
//                       setFloorModal(false);
//                       setEditRackModalOpen(false);
//                       rowReset();
//                     } else {
//                       toast.error("Please select a row first");
//                     }
//                   }}
//                   disabled={!isRackLevelEnabled}
//                   className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
//                     isRackLevelEnabled
//                       ? "bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
//                       : "bg-gray-200 text-gray-500 cursor-not-allowed"
//                   }`}
//                 >
//                   <span className="flex items-center justify-center gap-1.5">
//                     <span>📦</span> Rack Level
//                   </span>
//                 </button>

//                 <button
//                   onClick={() => {
//                     if (!selectedRow) {
//                       toast.error("Please select a row first");
//                     } else if (!isFloorEnabled) {
//                       toast.error(
//                         "All available floor positions in this row are occupied or blocked by consecutive floor constraints.",
//                       );
//                     } else {
//                       setFloorModal(true);
//                       setModal(false);
//                       setRow(false);
//                       setRackLevelModal(false);
//                       setEditRackModalOpen(false);
//                       rowReset();
//                     }
//                   }}
//                   disabled={!isFloorEnabled}
//                   title={
//                     !isFloorEnabled && selectedRow
//                       ? "No available floor slots in this row due to occupancy or consecutive constraints"
//                       : ""
//                   }
//                   className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
//                     isFloorEnabled
//                       ? "bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
//                       : "bg-gray-200 text-gray-500 cursor-not-allowed"
//                   }`}
//                 >
//                   <span className="flex items-center justify-center gap-1.5">
//                     <span>🏢</span> Floor
//                   </span>
//                 </button>
//               </div>

//               {/* Enhanced Contextual Actions */}
//               {selectedRack &&
//                 (() => {
//                   const isRackActionsDisabled =
//                     (selectedRackParentRow as any)?.status === "INACTIVE";
//                   return (
//                     <div className="mt-4 pt-4 border-t border-slate-200 animate-slideDown">
//                       <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
//                         <span className="text-blue-500">▸</span>
//                         Rack Actions: {selectedRack.name}
//                         <span className="text-[10px] text-slate-400 font-normal">
//                           #{selectedRack.id?.slice(0, 6)}
//                         </span>
//                       </h4>
//                       <div className="grid grid-cols-2 gap-2">
//                         {selectedRack.status !== "INACTIVE" && (
//                           <button
//                             onClick={() => {
//                               if (isRackActionsDisabled) {
//                                 toast.error(
//                                   "Parent row is archived. Please restore it first.",
//                                 );
//                                 return;
//                               }
//                               setEditRackModalOpen(true);
//                               setModal(false);
//                               setRow(false);
//                               setRackLevelModal(false);
//                               setFloorModal(false);
//                             }}
//                             disabled={isRackActionsDisabled}
//                             className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
//                               isRackActionsDisabled
//                                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                             }`}
//                           >
//                             <span className="flex items-center justify-center gap-1">
//                               <span>➕</span> Add Levels
//                             </span>
//                           </button>
//                         )}
//                         <button
//                           onClick={() => {
//                             if (isRackActionsDisabled) {
//                               toast.error(
//                                 "Parent row is archived. Please restore it first.",
//                               );
//                               return;
//                             }
//                             const isInactive =
//                               selectedRack.status === "INACTIVE";
//                             setRackArchiveConfirmModal({
//                               open: true,
//                               rack: selectedRack,
//                               action: isInactive ? "restore" : "archive",
//                             });
//                           }}
//                           disabled={
//                             isRackActionsDisabled ||
//                             (selectedRack.status !== "INACTIVE" &&
//                               getRackInventory(selectedRack) > 0)
//                           }
//                           title={
//                             selectedRack.status !== "INACTIVE" &&
//                             getRackInventory(selectedRack) > 0
//                               ? `Cannot archive rack with active inventory (${getRackInventory(selectedRack)} items stored)`
//                               : ""
//                           }
//                           className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
//                             isRackActionsDisabled ||
//                             (selectedRack.status !== "INACTIVE" &&
//                               getRackInventory(selectedRack) > 0)
//                               ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                               : selectedRack.status === "INACTIVE"
//                                 ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                                 : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                           }`}
//                         >
//                           <span className="flex items-center justify-center gap-1">
//                             <span>
//                               {selectedRack.status === "INACTIVE" ? "♻️" : "🗑️"}
//                             </span>
//                             {selectedRack.status === "INACTIVE"
//                               ? "Restore"
//                               : "Archive"}
//                           </span>
//                         </button>
//                       </div>
//                       {/* Rack Inventory Summary */}
//                       {selectedRack.status !== "INACTIVE" && (
//                         <div className="mt-2 p-2 bg-slate-50 rounded-lg text-[10px] text-slate-500">
//                           <span className="font-medium">Inventory:</span>{" "}
//                           {getRackInventory(selectedRack)} items across{" "}
//                           {selectedRack.level?.length || 0} levels
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })()}

//               {selectedRow &&
//                 !selectedRack &&
//                 (() => {
//                   const rowInventory = getRowInventory(selectedRow);
//                   const isArchiveDisabled =
//                     selectedRow.status !== "INACTIVE" && rowInventory > 0;
//                   return (
//                     <div className="mt-4 pt-4 border-t border-slate-200 animate-slideDown">
//                       <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
//                         <span className="text-amber-500">▸</span>
//                         Row Actions: {selectedRow.name}
//                       </h4>
//                       <div className="grid grid-cols-2 gap-2">
//                         <button
//                           onClick={() => {
//                             setEditRowNameModal({
//                               open: true,
//                               row: selectedRow,
//                             });
//                           }}
//                           className="w-full rounded-xl px-3 py-2 text-sm font-medium bg-gradient-to-r from-slate-600 to-slate-700 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02] transition-all"
//                         >
//                           <span className="flex items-center justify-center gap-1">
//                             <span>✏️</span> Edit Name
//                           </span>
//                         </button>
//                         <button
//                           onClick={() => {
//                             const isInactive =
//                               selectedRow.status === "INACTIVE";
//                             setRowArchiveConfirmModal({
//                               open: true,
//                               row: selectedRow,
//                               action: isInactive ? "restore" : "archive",
//                             });
//                           }}
//                           disabled={isArchiveDisabled}
//                           title={
//                             isArchiveDisabled
//                               ? `Cannot archive row with active inventory (${rowInventory} items stored)`
//                               : ""
//                           }
//                           className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
//                             isArchiveDisabled
//                               ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                               : selectedRow.status === "INACTIVE"
//                                 ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                                 : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                           }`}
//                         >
//                           <span className="flex items-center justify-center gap-1">
//                             <span>
//                               {selectedRow.status === "INACTIVE" ? "♻️" : "🗑️"}
//                             </span>
//                             {selectedRow.status === "INACTIVE"
//                               ? "Restore"
//                               : "Archive"}
//                           </span>
//                         </button>
//                       </div>
//                       {/* Row Stats */}
//                       <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
//                         <span className="flex items-center gap-1">
//                           <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
//                           {selectedRow.rack?.filter(
//                             (r: any) => r.status !== "INACTIVE",
//                           ).length || 0}{" "}
//                           Active Racks
//                         </span>
//                         <span className="flex items-center gap-1">
//                           <span className="w-1.5 h-1.5 rounded-full bg-slate-400"></span>
//                           {selectedRow.rack?.filter(
//                             (r: any) => r.status === "INACTIVE",
//                           ).length || 0}{" "}
//                           Archived
//                         </span>
//                       </div>
//                     </div>
//                   );
//                 })()}

//               {selectedFloor &&
//                 !selectedRack &&
//                 !selectedRow &&
//                 (() => {
//                   const isFloorParentArchivedOnly =
//                     (selectedFloorParentRow as any)?.status === "INACTIVE";
//                   const isFloorActionsDisabled =
//                     isFloorParentArchivedOnly ||
//                     selectedFloor.status === "INACTIVE";

//                   return (
//                     <div className="mt-4 pt-4 border-t border-slate-200 animate-slideDown">
//                       <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
//                         <span className="text-emerald-500">▸</span>
//                         Floor Actions: {selectedFloor.name}
//                       </h4>
//                       <div className="grid grid-cols-2 gap-2">
//                         {selectedFloor.status !== "INACTIVE" && (
//                           <button
//                             onClick={() => {
//                               if (isFloorActionsDisabled) {
//                                 toast.error(
//                                   "Parent element is archived. Please restore it first.",
//                                 );
//                                 return;
//                               }
//                               setPalletModalOpen(true);
//                             }}
//                             disabled={isFloorActionsDisabled}
//                             className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
//                               isFloorActionsDisabled
//                                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-violet-500 to-purple-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                             }`}
//                           >
//                             <span className="flex items-center justify-center gap-1">
//                               <span>
//                                 {selectedFloor.pallet &&
//                                 selectedFloor.pallet.length > 0
//                                   ? "➕"
//                                   : "📦"}
//                               </span>
//                               {selectedFloor.pallet &&
//                               selectedFloor.pallet.length > 0
//                                 ? "Add More Pallets"
//                                 : "Create Pallet"}
//                             </span>
//                           </button>
//                         )}
//                         <button
//                           onClick={() => {
//                             if (isFloorParentArchivedOnly) {
//                               toast.error(
//                                 "Parent element is archived. Please restore it first.",
//                               );
//                               return;
//                             }
//                             const isInactive =
//                               selectedFloor.status === "INACTIVE";
//                             setFloorArchiveConfirmModal({
//                               open: true,
//                               floor: selectedFloor,
//                               action: isInactive ? "restore" : "archive",
//                             });
//                           }}
//                           disabled={
//                             isFloorParentArchivedOnly ||
//                             (selectedFloor.status !== "INACTIVE" &&
//                               getFloorInventory(selectedFloor) > 0)
//                           }
//                           title={
//                             selectedFloor.status !== "INACTIVE" &&
//                             getFloorInventory(selectedFloor) > 0
//                               ? `Cannot archive floor with active inventory (${getFloorInventory(selectedFloor)} items stored)`
//                               : ""
//                           }
//                           className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
//                             isFloorParentArchivedOnly ||
//                             (selectedFloor.status !== "INACTIVE" &&
//                               getFloorInventory(selectedFloor) > 0)
//                               ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                               : selectedFloor.status === "INACTIVE"
//                                 ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                                 : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                           }`}
//                         >
//                           <span className="flex items-center justify-center gap-1">
//                             <span>
//                               {selectedFloor.status === "INACTIVE"
//                                 ? "♻️"
//                                 : "🗑️"}
//                             </span>
//                             {selectedFloor.status === "INACTIVE"
//                               ? "Restore"
//                               : "Archive"}
//                           </span>
//                         </button>
//                       </div>
//                       {/* Floor Stats */}
//                       {selectedFloor.status !== "INACTIVE" && (
//                         <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
//                           <span className="flex items-center gap-1">
//                             📦 {selectedFloor.pallet?.length || 0} Pallets
//                           </span>
//                           <span className="flex items-center gap-1">
//                             📊 {getFloorInventory(selectedFloor)} Items
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })()}

//               {selectedLevel &&
//                 !selectedRack &&
//                 !selectedRow &&
//                 !selectedFloor &&
//                 (() => {
//                   const hasBins =
//                     selectedLevel.bin && selectedLevel.bin.length > 0;
//                   const hasPallets =
//                     selectedLevel.pallet && selectedLevel.pallet.length > 0;
//                   const isLevelParentArchived =
//                     selectedLevelParentRack?.status === "INACTIVE" ||
//                     (selectedLevelParentRow as any)?.status === "INACTIVE";
//                   const isLevelAddDisabled =
//                     isLevelParentArchived ||
//                     selectedLevel.status === "INACTIVE";

//                   return (
//                     <div className="mt-4 pt-4 border-t border-slate-200 animate-slideDown">
//                       <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
//                         <span className="text-indigo-500">▸</span>
//                         Level Actions: {selectedLevel.name}
//                       </h4>
//                       <div className="grid grid-cols-2 gap-2">
//                         {selectedLevel.status !== "INACTIVE" && !hasPallets && (
//                           <button
//                             onClick={() => {
//                               if (isLevelAddDisabled) {
//                                 toast.error(
//                                   "Parent elements are archived. Please restore them first.",
//                                 );
//                                 return;
//                               }
//                               setPreselectedType("bins");
//                               setBinModalOpen(true);
//                             }}
//                             disabled={isLevelAddDisabled}
//                             className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
//                               isLevelAddDisabled
//                                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-indigo-500 to-blue-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                             }`}
//                           >
//                             <span className="flex items-center justify-center gap-1">
//                               <span>{hasBins ? "➕" : "📦"}</span>
//                               {hasBins ? "Add More Bins" : "Create Bin"}
//                             </span>
//                           </button>
//                         )}
//                         {selectedLevel.status !== "INACTIVE" && !hasBins && (
//                           <button
//                             onClick={() => {
//                               if (isLevelAddDisabled) {
//                                 toast.error(
//                                   "Parent elements are archived. Please restore them first.",
//                                 );
//                                 return;
//                               }
//                               setPreselectedType("pallets");
//                               setBinModalOpen(true);
//                             }}
//                             disabled={isLevelAddDisabled}
//                             className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
//                               isLevelAddDisabled
//                                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-violet-500 to-purple-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                             }`}
//                           >
//                             <span className="flex items-center justify-center gap-1">
//                               <span>{hasPallets ? "➕" : "📦"}</span>
//                               {hasPallets
//                                 ? "Add More Pallets"
//                                 : "Create Pallet"}
//                             </span>
//                           </button>
//                         )}
//                         <button
//                           onClick={() => {
//                             if (isLevelParentArchived) {
//                               toast.error(
//                                 "Parent elements are archived. Please restore them first.",
//                               );
//                               return;
//                             }
//                             const isInactive =
//                               selectedLevel.status === "INACTIVE";
//                             setLevelArchiveConfirmModal({
//                               open: true,
//                               level: selectedLevel,
//                               action: isInactive ? "restore" : "archive",
//                             });
//                           }}
//                           disabled={
//                             isLevelParentArchived ||
//                             (selectedLevel.status !== "INACTIVE" &&
//                               getLevelInventory(selectedLevel) > 0)
//                           }
//                           title={
//                             selectedLevel.status !== "INACTIVE" &&
//                             getLevelInventory(selectedLevel) > 0
//                               ? `Cannot archive level with active inventory (${getLevelInventory(selectedLevel)} items stored)`
//                               : ""
//                           }
//                           className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
//                             isLevelParentArchived ||
//                             (selectedLevel.status !== "INACTIVE" &&
//                               getLevelInventory(selectedLevel) > 0)
//                               ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                               : selectedLevel.status === "INACTIVE"
//                                 ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                                 : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
//                           }`}
//                         >
//                           <span className="flex items-center justify-center gap-1">
//                             <span>
//                               {selectedLevel.status === "INACTIVE"
//                                 ? "♻️"
//                                 : "🗑️"}
//                             </span>
//                             {selectedLevel.status === "INACTIVE"
//                               ? "Restore"
//                               : "Archive"}
//                           </span>
//                         </button>
//                       </div>
//                       {/* Level Stats */}
//                       {selectedLevel.status !== "INACTIVE" && (
//                         <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
//                           <span className="flex items-center gap-1">
//                             📦 {selectedLevel.bin?.length || 0} Bins
//                           </span>
//                           <span className="flex items-center gap-1">
//                             📦 {selectedLevel.pallet?.length || 0} Pallets
//                           </span>
//                           <span className="flex items-center gap-1">
//                             📊 {getLevelInventory(selectedLevel)} Items
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })()}
//             </div>
//           )}
 
//           {modal && (
//             <CreateZoneAreaModal
//               open={modal}
//               onClose={() => setModal(false)}
//               register={register}
//               errors={errors}
//               clearErrors={clearErrors}
//               setValue={setValue}
//               watch={watch}
//               isPending={isPending}
//               handleSubmit={handleSubmit(handleCreateShelve)}
//             />
//           )}

//           {row && (
//             <CreateRowOnlyModal
//               open={row}
//               modalType="create"
//               onClose={() => {
//                 setRow(false);
//                 rowReset();
//               }}
//               setValue={setRowValue}
//               watch={rowWatch}
//               register={rowRegister}
//               errors={rowErrors}
//               clearErrors={rowClearErrors}
//               isPending={isCreateRowPending}
//               control={rowControl}
//               handleSubmit={handleRowSubmit(handleCreateRow)}
//               rackInstanceId={""}
//               shelveId={currentAreaId}
//               warehouseId={""}
//               clientId={""}
//               fetchShelves={() => {}}
//               rowId={""}
//             />
//           )}

//           {rackLevelModal && (
//             <CreateRowModal
//               open={rackLevelModal}
//               hideModeToggle={true}
//               onClose={() => {
//                 setRackLevelModal(false);
//                 rowReset();
//               }}
//               setValue={setRowValue}
//               watch={rowWatch}
//               register={rowRegister}
//               errors={rowErrors}
//               clearErrors={rowClearErrors}
//               isPending={isRowPending}
//               control={rowControl}
//               handleSubmit={handleRowSubmit(handleCreateRackLevel)}
//               rackInstanceId={""}
//               shelveId={currentAreaId}
//               warehouseId={selectedWarehouseId}
//               clientId={selectedWarehouse?.clientId}
//               fetchShelves={() => {
//                 refetchShelveRows();
//                 refetchFloorList();
//               }}
//               rowId={selectedRow?.id ?? ""}
//               rows={shelveRows}
//               floorsByRack={floorsByRack}
//               floorsByRow={floorsByRow}
//             />
//           )}

//           {floorModal && (
//             // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
//             <div className="bg-[#F7F6F2] rounded-3xl   overflow-hidden shadow-2xl flex flex-col">
//               <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
//                 <div>
//                   <h2 className="text-lg font-bold text-[#212121]">
//                     Add Floor Storage
//                   </h2>
//                   <p className="text-xs text-gray-500">
//                     Create floor storage in {selectedRow?.name}
//                   </p>
//                 </div>
//                 <button
//                   onClick={() => {
//                     setFloorModal(false);
//                   }}
//                   className="p-2 hover:bg-gray-100 rounded-full transition"
//                 >
//                   <IconX size={20} />
//                 </button>
//               </div>
//               <CreateFloorModal
//                 shelveId={currentAreaId}
//                 fetchShelves={() => {
//                   refetchFloorList();
//                   refetchShelveRows();
//                 }}
//                 rows={shelveRows}
//                 selectedRow={selectedRow}
//                 floorsByRack={floorsByRack}
//                 floorsByRow={floorsByRow}
//                 onClose={() => {
//                   setFloorModal(false);
//                 }}
//               />
//             </div>
//             // </div>
//           )}

//           {editRackModalOpen && (
//             <EditRackModal
//               open={editRackModalOpen}
//               inline={true}
//               onClose={() => setEditRackModalOpen(false)}
//               register={editRackRegister}
//               setValue={setEditRackValue}
//               control={editRackControl}
//               errors={editRackErrors}
//               handleSubmit={handleEditRackSubmit(handleEditRack)}
//               isPending={isRackUpdatePending}
//               defaultValues={editRackDefaultValues}
//             />
//           )}

//           {binModalOpen && (selectedRack || selectedLevelParentRack) && (
//             <CreateBinsModal
//               open={binModalOpen}
//               onClose={() => setBinModalOpen(false)}
//               rackLevels={
//                 (selectedRack || selectedLevelParentRack)?.level || []
//               }
//               rackInstanceId={(selectedRack || selectedLevelParentRack)?.id}
//               warehouseId={selectedWarehouseId}
//               clientId={selectedWarehouse?.clientId}
//               storageType={
//                 selectedArea?.storageType === "B2C" ? "Shelves" : "Bins"
//               }
//               fetchShelves={() => {
//                 refetchShelveRows();
//                 refetchFloorList();
//               }}
//               rowId={selectedRow?.id || selectedLevelParentRow?.id}
//               shelveId={""}
//               areaId={currentAreaId || ""}
//               preselectedLevelId={selectedLevel?.id}
//               preselectedType={preselectedType}
//             />
//           )}

//           {palletModalOpen && selectedFloor && (
//             <CreatePalletModal
//               open={palletModalOpen}
//               onClose={() => setPalletModalOpen(false)}
//               warehouseId={selectedWarehouseId}
//               clientId={selectedWarehouse?.clientId}
//               fetchShelves={() => {
//                 refetchShelveRows();
//                 refetchFloorList();
//               }}
//               floorId={selectedFloor.id}
//               floorName={selectedFloor.name}
//               areaId={currentAreaId}
//             />
//           )}

//           {floorArchiveConfirmModal.open && (
//             <MessageModal
//               open={floorArchiveConfirmModal.open}
//               onClose={() =>
//                 setFloorArchiveConfirmModal({
//                   open: false,
//                   floor: null,
//                   action: "archive",
//                 })
//               }
//               title={
//                 floorArchiveConfirmModal.action === "archive"
//                   ? "Archive Floor Area?"
//                   : "Reactivate Floor Area?"
//               }
//               subtitle={
//                 floorArchiveConfirmModal.action === "archive"
//                   ? "Hide this floor area and its contents from daily operations."
//                   : "Return this floor area to active daily operations."
//               }
//               img={
//                 floorArchiveConfirmModal.action === "archive"
//                   ? "/img/archive.png"
//                   : "/img/restore.png"
//               }
//               showFooter={true}
//               actionButtonText={
//                 floorArchiveConfirmModal.action === "archive"
//                   ? "Confirm Archive"
//                   : "Confirm Restore"
//               }
//               actionButtonOnClick={() => {
//                 archiveMutation.mutate(
//                   {
//                     id: floorArchiveConfirmModal.floor.id,
//                     status:
//                       floorArchiveConfirmModal.action === "archive"
//                         ? "INACTIVE"
//                         : "ACTIVE",
//                     model: "floor",
//                   },
//                   {
//                     onSuccess: () => {
//                       toast.success(
//                         floorArchiveConfirmModal.action === "archive"
//                           ? "Floor archived successfully"
//                           : "Floor restored successfully",
//                       );
//                       setFloorArchiveConfirmModal({
//                         open: false,
//                         floor: null,
//                         action: "archive",
//                       });
//                       setSelectedFloor(null);
//                       refetchShelveRows();
//                       refetchFloorList();
//                     },
//                     onError: (error: any) => {
//                       toast.error(
//                         `Failed to ${floorArchiveConfirmModal.action} floor: ${error.message}`,
//                       );
//                     },
//                   },
//                 );
//               }}
//               isPending={archiveMutation.isPending}
//             />
//           )}

//           {rowArchiveConfirmModal.open && (
//             <MessageModal
//               open={rowArchiveConfirmModal.open}
//               onClose={() =>
//                 setRowArchiveConfirmModal({
//                   open: false,
//                   row: null,
//                   action: "archive",
//                 })
//               }
//               title={
//                 rowArchiveConfirmModal.action === "archive"
//                   ? "Archive Row?"
//                   : "Reactivate Row?"
//               }
//               subtitle={
//                 rowArchiveConfirmModal.action === "archive"
//                   ? "Hide this row and its contents from daily operations."
//                   : "Return this row to active daily operations."
//               }
//               img={
//                 rowArchiveConfirmModal.action === "archive"
//                   ? "/img/archive.png"
//                   : "/img/restore.png"
//               }
//               showFooter={true}
//               actionButtonText={
//                 rowArchiveConfirmModal.action === "archive"
//                   ? "Confirm Archive"
//                   : "Confirm Restore"
//               }
//               actionButtonOnClick={() => {
//                 archiveMutation.mutate(
//                   {
//                     id: rowArchiveConfirmModal.row.id,
//                     status:
//                       rowArchiveConfirmModal.action === "archive"
//                         ? "INACTIVE"
//                         : "ACTIVE",
//                     model: "row",
//                   },
//                   {
//                     onSuccess: () => {
//                       toast.success(
//                         rowArchiveConfirmModal.action === "archive"
//                           ? "Row archived successfully"
//                           : "Row restored successfully",
//                       );
//                       setRowArchiveConfirmModal({
//                         open: false,
//                         row: null,
//                         action: "archive",
//                       });
//                       setSelectedRow(null);
//                       refetchShelveRows();
//                       refetchFloorList();
//                     },
//                     onError: (error: any) => {
//                       toast.error(
//                         `Failed to ${rowArchiveConfirmModal.action} row: ${error.message}`,
//                       );
//                     },
//                   },
//                 );
//               }}
//               isPending={archiveMutation.isPending}
//             />
//           )}

//           {rackArchiveConfirmModal.open && (
//             <MessageModal
//               open={rackArchiveConfirmModal.open}
//               onClose={() =>
//                 setRackArchiveConfirmModal({
//                   open: false,
//                   rack: null,
//                   action: "archive",
//                 })
//               }
//               title={
//                 rackArchiveConfirmModal.action === "archive"
//                   ? "Archive Rack?"
//                   : "Reactivate Rack?"
//               }
//               subtitle={
//                 rackArchiveConfirmModal.action === "archive"
//                   ? "Hide this rack and its contents from daily operations."
//                   : "Return this rack to active daily operations."
//               }
//               img={
//                 rackArchiveConfirmModal.action === "archive"
//                   ? "/img/archive.png"
//                   : "/img/restore.png"
//               }
//               showFooter={true}
//               actionButtonText={
//                 rackArchiveConfirmModal.action === "archive"
//                   ? "Confirm Archive"
//                   : "Confirm Restore"
//               }
//               actionButtonOnClick={() => {
//                 archiveMutation.mutate(
//                   {
//                     id: rackArchiveConfirmModal.rack.id,
//                     status:
//                       rackArchiveConfirmModal.action === "archive"
//                         ? "INACTIVE"
//                         : "ACTIVE",
//                     model: "rack",
//                   },
//                   {
//                     onSuccess: () => {
//                       toast.success(
//                         rackArchiveConfirmModal.action === "archive"
//                           ? "Rack archived successfully"
//                           : "Rack restored successfully",
//                       );
//                       setRackArchiveConfirmModal({
//                         open: false,
//                         rack: null,
//                         action: "archive",
//                       });
//                       setSelectedRack(null);
//                       refetchShelveRows();
//                       refetchFloorList();
//                     },
//                     onError: (error: any) => {
//                       toast.error(
//                         `Failed to ${rackArchiveConfirmModal.action} rack: ${error.message}`,
//                       );
//                     },
//                   },
//                 );
//               }}
//               isPending={archiveMutation.isPending}
//             />
//           )}

//           {levelArchiveConfirmModal.open && (
//             <MessageModal
//               open={levelArchiveConfirmModal.open}
//               onClose={() =>
//                 setLevelArchiveConfirmModal({
//                   open: false,
//                   level: null,
//                   action: "archive",
//                 })
//               }
//               title={
//                 levelArchiveConfirmModal.action === "archive"
//                   ? "Archive Level?"
//                   : "Reactivate Level?"
//               }
//               subtitle={
//                 levelArchiveConfirmModal.action === "archive"
//                   ? "Hide this level and its contents from daily operations."
//                   : "Return this level to active daily operations."
//               }
//               img={
//                 levelArchiveConfirmModal.action === "archive"
//                   ? "/img/archive.png"
//                   : "/img/restore.png"
//               }
//               showFooter={true}
//               actionButtonText={
//                 levelArchiveConfirmModal.action === "archive"
//                   ? "Confirm Archive"
//                   : "Confirm Restore"
//               }
//               actionButtonOnClick={() => {
//                 archiveMutation.mutate(
//                   {
//                     id: levelArchiveConfirmModal.level.id,
//                     status:
//                       levelArchiveConfirmModal.action === "archive"
//                         ? "INACTIVE"
//                         : "ACTIVE",
//                     model: "level",
//                   },
//                   {
//                     onSuccess: () => {
//                       toast.success(
//                         levelArchiveConfirmModal.action === "archive"
//                           ? "Level archived successfully"
//                           : "Level restored successfully",
//                       );
//                       setLevelArchiveConfirmModal({
//                         open: false,
//                         level: null,
//                         action: "archive",
//                       });
//                       setSelectedLevel(null);
//                       refetchShelveRows();
//                       refetchFloorList();
//                     },
//                     onError: (error: any) => {
//                       toast.error(
//                         `Failed to ${levelArchiveConfirmModal.action} level: ${error.message}`,
//                       );
//                     },
//                   },
//                 );
//               }}
//               isPending={archiveMutation.isPending}
//             />
//           )}

//           {editRowNameModal.open && (
//             <EditRowNameModal
//               open={editRowNameModal.open}
//               onClose={() => setEditRowNameModal({ open: false, row: null })}
//               onSubmit={(data) => {
//                 updateRow(
//                   {
//                     name: data.name,
//                   },
//                   {
//                     onSuccess: () => {
//                       toast.success("Row name updated successfully");
//                       setEditRowNameModal({ open: false, row: null });
//                       refetchShelveRows();
//                       refetchFloorList();
//                     },
//                     onError: (error: any) => {
//                       toast.error(
//                         `Failed to update row name: ${error.message}`,
//                       );
//                     },
//                   },
//                 );
//               }}
//               isPending={isRowUpdatePending}
//               currentName={editRowNameModal.row?.name || ""}
//             />
//           )}
//         </div>
//       </div>

//       {openbluk && (
//         <ShelveBulkUploadModals
//           onClose={() => setOpenBluk(false)}
//           onResponseOpene={() => setOpenResponse(true)}
//         />
//       )}

//       {showFilter && (
//         <div className="fixed inset-0 z-50 flex justify-end">
//           <div
//             className="absolute inset-0 bg-black/40"
//             onClick={handleCloseFilter}
//           ></div>
//           <div className="relative w-[500px] h-full bg-white rounded-l-3xl shadow-lg overflow-auto transition-transform duration-300 ease-in-out">
//             <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
//               <div>
//                 <h2 className="text-lg font-semibold">
//                   Location Control Panel
//                 </h2>
//                 <p className="text-xs font-mono text-slate-500">
//                   {selectedLocation?.item?.barcodeLabel ||
//                     selectedLocation?.item?.name ||
//                     ""}
//                 </p>
//               </div>
//               <button
//                 onClick={handleCloseFilter}
//                 className="bg-[#F7F6F2] rounded-full p-1 cursor-pointer hover:bg-slate-200 transition-colors"
//               >
//                 <IconX size={24} />
//               </button>
//             </div>
//             <div className="p-4 space-y-4 pb-6">
//               <div className="border border-[#d2d2d2] shadow-inner p-4 space-y-2 rounded-2xl">
//                 <h2 className="text-lg font-semibold">Location Path</h2>
//                 <p className="text-xs flex items-center flex-wrap gap-1">
//                   {pathSegments.map((segment: string, index: number) => (
//                     <Fragment key={index}>
//                       {index > 0 && (
//                         <span className="text-slate-400">
//                           <IconChevronRight size={12} />
//                         </span>
//                       )}
//                       <span className="font-medium text-slate-700">
//                         {segment}
//                       </span>
//                     </Fragment>
//                   ))}
//                 </p>
//               </div>
//               {availableUnits > 0 && (
//                 <>
//                   <div className="border border-[#d2d2d2] shadow-inner p-4 space-y-2 rounded-2xl">
//                     <h2 className="text-lg font-semibold">
//                       Capacity & Allocation
//                     </h2>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Capacity Cap</p>
//                       <p className="text-xs font-semibold">{capacityCap}</p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">
//                         {isLocationReserved
//                           ? "Reserved Units"
//                           : "Available Units"}
//                       </p>
//                       <p className="text-xs font-semibold">
//                         {isInventoryLoading
//                           ? "Loading..."
//                           : availableUnits
//                             ? availableUnits
//                             : ""}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="border border-[#d2d2d2] shadow-inner p-4 space-y-2 rounded-2xl">
//                     <h2 className="text-lg font-semibold">
//                       Inventory Traceability
//                     </h2>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Product</p>
//                       <p
//                         className="text-xs font-medium text-slate-600 truncate max-w-[250px]"
//                         title={productNames}
//                       >
//                         {productNames}
//                       </p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">SKU</p>
//                       <p className="text-xs font-mono text-slate-600">{skus}</p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Batch</p>
//                       <p className="text-xs font-mono text-slate-600">{""}</p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Lot</p>
//                       <p className="text-xs font-mono text-slate-600">{lots}</p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Serial</p>
//                       <p className="text-xs font-mono text-slate-600">
//                         {serials}
//                       </p>
//                     </div>
//                     <div className="flex justify-between items-center border-b py-1">
//                       <p className="text-sm">Expiry</p>
//                       <p className="text-xs text-slate-600">{expiries}</p>
//                     </div>
//                   </div>
//                 </>
//               )}

//               <div className="border border-[#d2d2d2] shadow-inner p-4 rounded-2xl flex items-center gap-2 w-full">
//                 <div className="flex flex-col items-center justify-center w-full border p-4 space-y-2 rounded-2xl bg-white shadow-sm">
//                   {locationInventoryData?.[0]?.barcodeUrl ? (
//                     <img
//                       src={locationInventoryData[0].barcodeUrl}
//                       alt="location-barcode"
//                       className="w-full h-20 object-fill mix-blend-multiply"
//                     />
//                   ) : selectedLocation?.item?.barcodeLabel ? (
//                     <div className="w-full h-20 flex items-center justify-center p-1">
//                       <Barcode
//                         value={selectedLocation.item.barcodeLabel}
//                         height={70}
//                         width={2.2}
//                         className="w-full h-full max-w-full max-h-full"
//                       />
//                     </div>
//                   ) : selectedLocation?.item?.barcodeUrl ? (
//                     <img
//                       src={selectedLocation.item.barcodeUrl}
//                       alt="location-barcode"
//                       className="w-full h-20 object-fill mix-blend-multiply"
//                     />
//                   ) : (
//                     <div className="w-full h-20 flex items-center justify-center text-slate-300 text-xs font-medium">
//                       No Barcode
//                     </div>
//                   )}
//                   {!locationInventoryData?.[0]?.barcodeUrl &&
//                     !(
//                       !selectedLocation?.item?.barcodeLabel &&
//                       selectedLocation?.item?.barcodeUrl
//                     ) && (
//                       <p className="text-[10px] font-mono font-bold text-slate-700 uppercase truncate max-w-full">
//                         {selectedLocation?.item?.barcodeLabel || ""}
//                       </p>
//                     )}
//                 </div>
//                 <div className="flex flex-col items-center justify-center w-full border p-4 space-y-2 rounded-2xl bg-white shadow-sm">
//                   {locationInventoryData?.[0]?.skuBarcodeUrl ? (
//                     <img
//                       src={locationInventoryData[0].skuBarcodeUrl}
//                       alt="sku-barcode"
//                       className="w-full h-20 object-fill mix-blend-multiply"
//                     />
//                   ) : skus && skus !== "" && skus !== "Empty" ? (
//                     <div className="w-full h-20 flex items-center justify-center p-1">
//                       <Barcode
//                         value={skus}
//                         height={70}
//                         width={2.2}
//                         className="w-full h-full max-w-full max-h-full"
//                       />
//                     </div>
//                   ) : (
//                     <div className="w-full h-20 flex items-center justify-center text-slate-300 text-xs font-medium">
//                       No SKU Barcode
//                     </div>
//                   )}
//                   {!locationInventoryData?.[0]?.skuBarcodeUrl && (
//                     <p className="text-[10px] font-mono font-bold text-slate-700 uppercase truncate max-w-full">
//                       {skus || ""}
//                     </p>
//                   )}
//                 </div>
//               </div>

//               <div className="grid grid-cols-2 gap-4">
//                 <button className="bg-[#212121] rounded-full px-6 py-2 text-white">
//                   Transfer
//                 </button>
//                 <button className="bg-[#ffffff] rounded-full px-6 py-2 text-[#212121] border">
//                   Reserve
//                 </button>
//                 <button className="bg-[#ffffff] rounded-full px-6 py-2 text-[#212121] border">
//                   Cycle Count
//                 </button>
//                 <button className="bg-[#ffffff] rounded-full px-6 py-2 text-[#212121] border">
//                   Block
//                 </button>
//                 <button className="bg-[#ffffff] rounded-full px-6 py-2 text-[#212121] border">
//                   Print Label
//                 </button>
//                 <div className="relative group w-full">
//                   <button
//                     onClick={() => {
//                       if (
//                         selectedLocation?.item?.status !== "INACTIVE" &&
//                         hasActiveInventory
//                       )
//                         return;
//                       handleToggleLocationStatus();
//                     }}
//                     className={`w-full rounded-full px-6 py-2 transition-all ${
//                       selectedLocation?.item?.status === "INACTIVE"
//                         ? "bg-green-600 text-white hover:opacity-90 cursor-pointer"
//                         : hasActiveInventory
//                           ? "bg-gray-200 text-gray-500 cursor-not-allowed border-none"
//                           : "bg-red-500 text-white hover:opacity-90 cursor-pointer"
//                     }`}
//                   >
//                     {selectedLocation?.item?.status === "INACTIVE"
//                       ? "Restore"
//                       : "Archive"}
//                   </button>
//                   {selectedLocation?.item?.status !== "INACTIVE" &&
//                     hasActiveInventory && (
//                       <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block z-[70] pointer-events-none">
//                         <div className="whitespace-nowrap rounded-md bg-slate-800 px-3 py-1.5 text-xs text-white shadow-lg relative">
//                           Cannot archive a location with active inventory
//                           <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 rotate-45 bg-slate-800 -mt-1"></div>
//                         </div>
//                       </div>
//                     )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {locationArchiveConfirmModal.open && (
//         <MessageModal
//           open={locationArchiveConfirmModal.open}
//           onClose={() =>
//             setLocationArchiveConfirmModal({
//               open: false,
//               item: null,
//               type: "bin",
//               action: "archive",
//             })
//           }
//           title={
//             locationArchiveConfirmModal.action === "archive"
//               ? `Archive ${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"}?`
//               : `Reactivate ${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"}?`
//           }
//           subtitle={
//             locationArchiveConfirmModal.action === "archive"
//               ? `Hide this ${locationArchiveConfirmModal.type === "bin" ? "bin" : "pallet"} and its contents from daily operations.`
//               : `Return this ${locationArchiveConfirmModal.type === "bin" ? "bin" : "pallet"} to active daily operations.`
//           }
//           img={
//             locationArchiveConfirmModal.action === "archive"
//               ? "/img/archive.png"
//               : "/img/restore.png"
//           }
//           showFooter={true}
//           actionButtonText={
//             locationArchiveConfirmModal.action === "archive"
//               ? "Confirm Archive"
//               : "Confirm Restore"
//           }
//           actionButtonOnClick={() => {
//             archiveMutation.mutate(
//               {
//                 id: locationArchiveConfirmModal.item.id,
//                 status:
//                   locationArchiveConfirmModal.action === "archive"
//                     ? "INACTIVE"
//                     : "ACTIVE",
//                 model: locationArchiveConfirmModal.type,
//               },
//               {
//                 onSuccess: () => {
//                   toast.success(
//                     locationArchiveConfirmModal.action === "archive"
//                       ? `${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"} archived successfully`
//                       : `${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"} restored successfully`,
//                   );
//                   setLocationArchiveConfirmModal({
//                     open: false,
//                     item: null,
//                     type: "bin",
//                     action: "archive",
//                   });
//                   setSelectedLocation(null);
//                   setShowFilter(false);
//                   refetchShelveRows();
//                   refetchFloorList();
//                 },
//                 onError: (error: any) => {
//                   toast.error(
//                     `Failed to ${locationArchiveConfirmModal.action} ${locationArchiveConfirmModal.type}: ${error.message}`,
//                   );
//                 },
//               },
//             );
//           }}
//           isPending={archiveMutation.isPending}
//         />
//       )}

//       {/* Add CSS for animations */}
//       <style>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-10px) scale(0.98);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0) scale(1);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.3s ease-out;
//         }
//         .animate-slideDown {
//           animation: slideDown 0.25s ease-out;
//         }
//         .scrollbar-thin::-webkit-scrollbar {
//           width: 4px;
//           height: 4px;
//         }
//         .scrollbar-thin::-webkit-scrollbar-track {
//           background: transparent;
//         }
//         .scrollbar-thin::-webkit-scrollbar-thumb {
//           background: #cbd5e1;
//           border-radius: 9999px;
//         }
//         .scrollbar-thin::-webkit-scrollbar-thumb:hover {
//           background: #94a3b8;
//         }
//       `}</style>
//     </div>
//   );
// }



import {
  IconChevronRight,
  IconCloudUpload,
  IconDownload,
  IconPlus,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import { useEffect, useState, useMemo, Fragment } from "react";
import RoleToggle from "../../../components/RoleToggle";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import CreateZoneAreaModal from "./CreateZoneAreaModal";
import CreateRowOnlyModal from "./CreateRowOnlyModel";
import EditRowNameModal from "./EditRowNameModal";
import CreateRowModal from "./CreateRowModal";
import CreateFloorModal from "./CreateFloorModal";
import ShelveBulkUploadModals from "./ShelveBulkUploadModals";
import MessageModal from "../../../components/MessageModal";
import FloorElement from "./FloorElement";
import RackLevelElement from "./RackInstanceElement";
import CreateBinsModal from "./CreateBinsModal";
import CreatePalletModal from "./CreatePalletModal";
import EditRackModal from "./EditRackModal";
import Barcode from "../../../components/common/Barcode";
import InteractiveShelvingOperatorPortal from "./InteractiveShelvingOperatorPortal";
import { useForm } from "react-hook-form";
import {
  useDownloadShelveBarcode,
  useFetchShelfAllData,
  useFetchShelfAreaFloors,
  useFetchShelfRowsAllData,
  useShelfCreateMutation,
  useShelfRowWhRowCreateMutation,
  useShelfRowCreateMutation,
  useShelfRowUpdateMutation,
  useAdminRacksUpdateMutation,
  useFetchLocationInventory,
} from "../../../hooks/shelveHooks";
import { useUpdateShelveStatusMutation } from "../../../apis/shelveApis";
import toast from "react-hot-toast"; 
import { usePermission } from "../../../hooks/usePermissionTabs";
import InventoryTabMain from "../inventory-tab";
import { useFetchProductItemInventoryData } from "../../../apis/productManifestApis";
import { useShipmentInventoryListData, useFetchShipmentInventoryDataByLocation } from "../../../hooks/inventoryHooks";
import { useLanguage, T } from "../../../context/LanguageContext";

export default function ShelveLocationTab() {
  const { t } = useLanguage();
  const { allowed: canCreateShelves } = usePermission("shelves", "create");
  const { allowed: canUpdateShelves } = usePermission("shelves", "update");
  const { allowed: canDeleteShelves } = usePermission("shelves", "delete");
  const { allowed: canCreateProductInventory } = usePermission("product_inventory", "create");
  // View toggle state
  const [activeView, setActiveView] = useState<"heatmap" | "inventory">("heatmap");
  const [activeFilter, setActiveFilter] = useState<string>("All");
  const [inventoryActiveTab, setInventoryActiveTab] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryWiseActiveRole");
    return saved || "ShipmentInventory";
  });
  const [inventoryActiveSubTab, setInventoryActiveSubTab] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryCheckActiveRole");
    return saved || "Inventory";
  });

  const filterItem = (item: any, filter: string) => {
    if (filter === "All") return true;
    if (filter === "Active") return item.status !== "INACTIVE";
    if (filter === "Archived") return item.status === "INACTIVE";
    if (filter === "Full") return (item.currentInventoryCount || 0) > 0;
    if (filter === "Empty") return !(item.currentInventoryCount && item.currentInventoryCount > 0);
    return true;
  };

  const [showShelveSkuModal, setShowShelveSkuModal] = useState(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [showActions, setShowActions] = useState(false);
  const [searchFor, setSearchFor] = useState<string>("");
  const [selectedLocation, setSelectedLocation] = useState<any>(null);
  console.log("selectedLocation", selectedLocation);

  const [locationArchiveConfirmModal, setLocationArchiveConfirmModal] =
    useState<{
      open: boolean;
      item: any;
      type: "bin" | "pallet";
      action: "archive" | "restore";
    }>({ open: false, item: null, type: "bin", action: "archive" });

  const handleToggleLocationStatus = () => {
    if (!selectedLocation?.item) return;
    const isInactive = selectedLocation.item.status === "INACTIVE";
    setLocationArchiveConfirmModal({
      open: true,
      item: selectedLocation.item,
      type: selectedLocation.type,
      action: isInactive ? "restore" : "archive",
    });
  };

  const handleSelectLocation = (location: any) => {
    setSelectedLocation(location);
    setSelectedRow(null);
    setSelectedRack(null);
    setSelectedFloor(null);
    setSelectedLevel(null);
    setShowActions(false);
    setModal(false);
    setRow(false);
    setRackLevelModal(false);
    setFloorModal(false);
    setEditRackModalOpen(false);
  };

  const handleCloseFilter = () => {
    setSelectedLocation(null);
    setShowActions(false);
  };

  // Selection states for action flow
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>(null);
  const [selectedArea, setSelectedArea] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRack, setSelectedRack] = useState<any>(null);
  const [selectedFloor, setSelectedFloor] = useState<any>(null);
  const [selectedLevel, setSelectedLevel] = useState<any>(null);
  const [levelArchiveConfirmModal, setLevelArchiveConfirmModal] = useState<{
    open: boolean;
    level: any;
    action: "archive" | "restore";
  }>({ open: false, level: null, action: "archive" });
  const [preselectedType, setPreselectedType] = useState<
    "bins" | "pallets" | undefined
  >(undefined);

  // Modal states
  const [floorArchiveConfirmModal, setFloorArchiveConfirmModal] = useState<{
    open: boolean;
    floor: any;
    action: "archive" | "restore";
  }>({ open: false, floor: null, action: "archive" });
  const [rowArchiveConfirmModal, setRowArchiveConfirmModal] = useState<{
    open: boolean;
    row: any;
    action: "archive" | "restore";
  }>({ open: false, row: null, action: "archive" });
  const [rackArchiveConfirmModal, setRackArchiveConfirmModal] = useState<{
    open: boolean;
    rack: any;
    action: "archive" | "restore";
  }>({ open: false, rack: null, action: "archive" });
  const [modal, setModal] = useState<boolean>(false);
  const [row, setRow] = useState<boolean>(false);
  const [rackLevelModal, setRackLevelModal] = useState<boolean>(false);
  const [floorModal, setFloorModal] = useState<boolean>(false);
  const [binModalOpen, setBinModalOpen] = useState(false);
  const [palletModalOpen, setPalletModalOpen] = useState(false);
  const [openbluk, setOpenBluk] = useState<boolean | string>(false);
  const [openResponse, setOpenResponse] = useState<boolean | string>(false);
  const [editRowNameModal, setEditRowNameModal] = useState<{
    open: boolean;
    row: any;
  }>({ open: false, row: null });
  const [editRackModalOpen, setEditRackModalOpen] = useState(false);

  // Form hooks
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<any>();

  const {
    register: editRackRegister,
    handleSubmit: handleEditRackSubmit,
    setValue: setEditRackValue,
    control: editRackControl,
    formState: { errors: editRackErrors },
  } = useForm<any>();

  const {
    register: rowRegister,
    handleSubmit: handleRowSubmit,
    clearErrors: rowClearErrors,
    reset: rowReset,
    setValue: setRowValue,
    watch: rowWatch,
    control: rowControl,
    formState: { errors: rowErrors },
  } = useForm<any>({
    defaultValues: {
      levels: [],
    },
  });

  // API hooks
  const { data: warehouses, refetch: refetchWarehouses } =
    useWarehouseListData();
  const { mutate, isPending } = useShelfCreateMutation();
  const { mutate: createRow, isPending: isCreateRowPending } =
    useShelfRowWhRowCreateMutation();
  const { mutate: rowMutate, isPending: isRowPending } =
    useShelfRowCreateMutation();
  const { mutate: updateRow, isPending: isRowUpdatePending } =
    useShelfRowUpdateMutation(editRowNameModal.row?.id || "");
  const archiveMutation = useUpdateShelveStatusMutation();
  const { mutateAsync: fetchBarcode, isPending: isDownloading } =
    useDownloadShelveBarcode();

  const [warehouse, setWarehouse] = useState<string>("");

  const { data: shelves, refetch: fetchShelves } = useFetchShelfAllData(
    warehouses?.warehouses?.find(
      (warehouseData: any) => warehouseData?.name === warehouse,
    )?.id,
  );

  const [area, setArea] = useState<string>("");

  const currentAreaId = shelves?.find(
    (shelve: any) => shelve?.name === area,
  )?.id;
  const selectedWarehouseId = warehouses?.warehouses?.find(
    (warehouseData: any) => warehouseData?.name === warehouse,
  )?.id;

  const { data: receivedData } = useFetchProductItemInventoryData(
    1,
    1,
    "",
    false,
    selectedWarehouseId,
  );

  const { data: reservedData } = useFetchProductItemInventoryData(
    1,
    1,
    "",
    true,
    selectedWarehouseId,
  );

  const receivedCount = receivedData?.total || 0;
  const reservedCount = reservedData?.total || 0;

  const { data: shipmentInventoryData } = useShipmentInventoryListData(
    1,
    10,
    "",
    selectedWarehouseId,
  );

  const shipmentTotalCount = shipmentInventoryData?.total || 0;

  const { mutate: updateRack, isPending: isRackUpdatePending } =
    useAdminRacksUpdateMutation(currentAreaId || "");

  const { data: shelveRows, refetch: refetchShelveRows } =
    useFetchShelfRowsAllData(
      shelves?.find((shelve: any) => shelve?.name === area)?.id ?? "",
      selectedWarehouseId,
    );

  const { data: floorList, refetch: refetchFloorList } =
    useFetchShelfAreaFloors(
      shelves?.find((shelve: any) => shelve?.name === area)?.id ?? "",
    );

  const isShipment = selectedLocation?.type === "shipment";

  const { data: locationInventoryData, isLoading: isInventoryLoading } =
    useFetchLocationInventory(isShipment ? "" : selectedLocation?.item?.id ?? "");

  const { data: shipmentLocationInventoryData, isLoading: isShipmentInventoryLoading } =
    useFetchShipmentInventoryDataByLocation(
      isShipment ? selectedLocation?.item?.barcodeLabel ?? "" : "",
      1,
      100,
      ""
    );

  const isInventoryLoadingFinal = isShipment ? isShipmentInventoryLoading : isInventoryLoading;

  const { productNames, skus, batches, expiries, serials, lots } = useMemo<{
    productNames: string;
    skus: string;
    batches: string;
    expiries: string;
    serials: string;
    lots: string;
  }>(() => {
    if (!locationInventoryData || locationInventoryData.length === 0) {
      return {
        productNames: "",
        skus: "",
        batches: "",
        expiries: "",
        serials: "",
        lots: "",
      };
    }

    const first = locationInventoryData[0];
    return {
      productNames: first.itemName || "",
      skus: first.sku || "",
      batches: first.batchId || "",
      expiries: first.expiryDate || "",
      serials: first.serialNumber || "",
      lots: first.lotId || first.lotNumber || first.lot || "",
    };
  }, [locationInventoryData]);

  const pathSegments = useMemo(() => {
    const segments = [
      warehouse,
      area,
      selectedLocation?.row?.name,
      selectedLocation?.floor?.name,
      selectedLocation?.rack?.name,
      selectedLocation?.level?.name,
      selectedLocation?.item?.name,
    ].filter(Boolean);
    return Array.from(new Set(segments));
  }, [warehouse, area, selectedLocation]);

  const availableUnits = useMemo(() => {
    if (isShipment) {
      return shipmentLocationInventoryData?.total || shipmentLocationInventoryData?.inventoryMovement?.length || 0;
    }
    if (!locationInventoryData) return 0;
    return locationInventoryData.reduce(
      (acc: number, inv: any) => acc + (inv.quantity || 0),
      0,
    );
  }, [locationInventoryData, isShipment, shipmentLocationInventoryData]);

  const isLocationReserved = useMemo(() => {
    if (
      selectedLocation?.item?.isReserved ||
      selectedLocation?.item?.is_reserved
    )
      return true;
    if (Array.isArray(locationInventoryData)) {
      return locationInventoryData.some(
        (inv: any) => inv.isReserved || inv.is_reserved,
      );
    }
    return false;
  }, [locationInventoryData, selectedLocation]);

  const capacityCap = useMemo(() => {
    if (!locationInventoryData || locationInventoryData.length === 0)
      return null;
    const firstItem = locationInventoryData[0];
    const storage = firstItem?.storage || [];

    // Resolve location type (selectedLocation?.type is "bin" or "pallet")
    const locType = String(selectedLocation?.type || "").toLowerCase();
    const isPallet = locType === "pallet" || locType === "pallets";

    if (isPallet) {
      const palletStorage = storage.find((s: any) => {
        const t = String(s?.type || s?.storageType || "").toUpperCase();
        return t === "PALLET" || t === "PALLETS";
      });
      return palletStorage ? parseInt(palletStorage.capacity) || 0 : null;
    } else {
      const binStorage = storage.find((s: any) => {
        const t = String(s?.type || s?.storageType || "").toUpperCase();
        return t === "BIN" || t === "BINS";
      });
      return binStorage ? parseInt(binStorage.capacity) || 0 : null;
    }
  }, [locationInventoryData, selectedLocation]);

  const hasActiveInventory = useMemo(() => {
    if (availableUnits > 0) return true;
    const item = selectedLocation?.item;
    if (item?.currentInventoryCount && item.currentInventoryCount > 0)
      return true;
    if (item?.current_inventory_count && item.current_inventory_count > 0)
      return true;
    return false;
  }, [availableUnits, selectedLocation]);

  const handlePrintLabel = () => {
    const item = selectedLocation?.item;
    const barcodeLabel = item?.barcodeLabel;
    const barcodeUrl = locationInventoryData?.[0]?.barcodeUrl || item?.barcodeUrl;

    // SKU Barcode
    const skuBarcodeUrl = locationInventoryData?.[0]?.skuBarcodeUrl;
    const hasSku = !isShipment && ((skuBarcodeUrl) || (skus && skus !== "" && skus !== "Empty"));

    if (!barcodeLabel && !barcodeUrl && !hasSku) {
      toast.error("No barcode available to print");
      return;
    }

    const printWindow = window.open("", "_blank", "width=600,height=800");
    if (!printWindow) {
      toast.error("Popup blocked! Please allow popups for this site.");
      return;
    }

    let labelHtml = "";

    // 1. Location Barcode
    if (barcodeLabel || barcodeUrl) {
      let locationBarcodeHtml = "";
      if (barcodeUrl) {
        locationBarcodeHtml = `<img src="${barcodeUrl}" style="max-width: 100%; height: auto; mix-blend-multiply: multiply;" />`;
      } else {
        locationBarcodeHtml = `<svg id="location-barcode" style="max-width: 100%; height: auto;"></svg>`;
      }

      labelHtml += `
        <div class="label-container">
          <div class="title">Warehouse Location</div>
          <div class="subtitle">Last Mile Logistics Systems</div>
          <div class="barcode-wrapper">
            ${locationBarcodeHtml}
          </div>
        </div>
      `;
    }

    // 2. SKU Barcode
    if (hasSku) {
      let skuBarcodeHtml = "";
      if (skuBarcodeUrl) {
        skuBarcodeHtml = `<img src="${skuBarcodeUrl}" style="max-width: 100%; height: auto; mix-blend-multiply: multiply;" />`;
      } else {
        skuBarcodeHtml = `<svg id="sku-barcode" style="max-width: 100%; height: auto;"></svg>`;
      }

      labelHtml += `
        <div class="label-container" style="margin-top: 25px;">
          <div class="title">Product SKU Barcode</div>
          <div class="subtitle">Last Mile Logistics Systems</div>
          <div class="barcode-wrapper">
            ${skuBarcodeHtml}
          </div>
        </div>
      `;
    }

    const htmlContent = `
      <html>
      <head>
        <title>Print Barcode Labels</title>
        <style>
          body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            margin: 0;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            min-height: 100vh;
            box-sizing: border-box;
            background-color: white;
          }
          .label-container {
            border: 2px dashed #ccc;
            padding: 25px;
            border-radius: 12px;
            text-align: center;
            max-width: 400px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            box-sizing: border-box;
            background-color: #ffffff;
          }
          .title {
            font-size: 15px;
            font-weight: bold;
            color: #1e293b;
            margin-bottom: 4px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .subtitle {
            font-size: 10px;
            color: #64748b;
            margin-bottom: 15px;
          }
          .barcode-wrapper {
            margin-bottom: 12px;
            width: 100%;
            display: flex;
            justify-content: center;
          }
          @media print {
            body {
              padding: 0;
              min-height: auto;
            }
            .label-container {
              border: none;
              padding: 10px;
              page-break-inside: avoid;
            }
            .no-print {
              display: none;
            }
          }
        </style>
        ${(!barcodeUrl || (hasSku && !skuBarcodeUrl)) ? '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js"></script>' : ''}
      </head>
      <body>
        ${labelHtml}

        <script>
          window.onload = function() {
            try {
              ${(!barcodeUrl && barcodeLabel) ? `
                JsBarcode("#location-barcode", "${barcodeLabel}", {
                  format: "CODE128",
                  width: 2.2,
                  height: 60,
                  displayValue: true,
                  margin: 10
                });
              ` : ''}

              ${(hasSku && !skuBarcodeUrl && skus) ? `
                JsBarcode("#sku-barcode", "${skus}", {
                  format: "CODE128",
                  width: 2.2,
                  height: 60,
                  displayValue: true,
                  margin: 10
                });
              ` : ''}
            } catch(e) {
              console.error("JsBarcode generation failed:", e);
            }
            
            setTimeout(function() {
              window.print();
              window.close();
            }, 600);
          };
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  // Effects
  useEffect(() => {
    localStorage.setItem("WarehouseActiveRole", warehouse);
    const warehouseObj = warehouses?.warehouses?.find(
      (w: any) => w?.name === warehouse,
    );
    setSelectedWarehouse(warehouseObj);
    setSelectedArea(null);
    setSelectedRow(null);
    setSelectedRack(null);
    setSelectedFloor(null);
    setSelectedLevel(null);
    setSelectedLocation(null);
    setShowActions(false);
  }, [warehouse, warehouses]);

  useEffect(() => {
    localStorage.setItem("AreaActiveRole", area);
    const areaObj = shelves?.find((s: any) => s?.name === area);
    setSelectedArea(areaObj);
    setSelectedRow(null);
    setSelectedRack(null);
    setSelectedFloor(null);
    setSelectedLevel(null);
    setSelectedLocation(null);
    setShowActions(false);
  }, [area, shelves]);

  useEffect(() => {
    if (selectedRow) {
      setSelectedRack(null);
      setSelectedFloor(null);
      setSelectedLevel(null);
      setSelectedLocation(null);
      setModal(false);
      setRow(false);
      setRackLevelModal(false);
      setFloorModal(false);
      setEditRackModalOpen(false);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (selectedFloor) {
      setSelectedRow(null);
      setSelectedRack(null);
      setSelectedLevel(null);
      setSelectedLocation(null);
      setModal(false);
      setRow(false);
      setRackLevelModal(false);
      setFloorModal(false);
      setEditRackModalOpen(false);
    }
  }, [selectedFloor]);

  useEffect(() => {
    if (selectedRack) {
      setSelectedRow(null);
      setSelectedFloor(null);
      setSelectedLevel(null);
      setSelectedLocation(null);
      setModal(false);
      setRow(false);
      setRackLevelModal(false);
      setFloorModal(false);
      setEditRackModalOpen(false);
    }
  }, [selectedRack]);

  useEffect(() => {
    if (selectedLevel) {
      setSelectedRow(null);
      setSelectedFloor(null);
      setSelectedRack(null);
      setSelectedLocation(null);
      setModal(false);
      setRow(false);
      setRackLevelModal(false);
      setFloorModal(false);
      setEditRackModalOpen(false);
    }
  }, [selectedLevel]);

  const selectedLevelParentRack = useMemo(() => {
    if (!selectedLevel || !shelveRows) return null;
    return shelveRows
      .flatMap((row: any) => row.rack || [])
      .find((rack: any) =>
        rack.level?.some((lvl: any) => lvl.id === selectedLevel.id),
      );
  }, [selectedLevel, shelveRows]);

  const selectedLevelParentRow = useMemo(() => {
    if (!selectedLevel || !shelveRows) return null;
    return shelveRows.find((row: any) =>
      row.rack?.some((rack: any) =>
        rack.level?.some((lvl: any) => lvl.id === selectedLevel.id),
      ),
    );
  }, [selectedLevel, shelveRows]);

  const selectedRackParentRow = useMemo(() => {
    if (!selectedRack || !shelveRows) return null;
    return shelveRows.find((row: any) =>
      row.rack?.some((rack: any) => rack.id === selectedRack.id),
    );
  }, [selectedRack, shelveRows]);

  const editRackDefaultValues = useMemo(
    () => ({
      name: selectedRack?.name,
      levels: selectedRack?.level,
    }),
    [selectedRack],
  );

  const getFloorsByRow = (floors: any[], rows: any[]) => {
    const mappedFloors: { [key: string]: any[] } = {};
    rows.forEach((row) => {
      mappedFloors[row.id] = [];
    });
    floors.forEach((floor) => {
      const rackId = floor.whRackId || floor.wh_rack_id;
      if (rackId) return;

      const afterRowId = floor.after_wh_row_id;
      if (afterRowId && mappedFloors[afterRowId]) {
        mappedFloors[afterRowId].push(floor);
      } else {
        if (!mappedFloors["last_row"]) {
          mappedFloors["last_row"] = [];
        }
        mappedFloors["last_row"].push(floor);
      }
    });
    return mappedFloors;
  };

  // Group rack-nested floors by rack ID
  // Note: API returns snake_case (wh_rack_id) due to Sequelize underscored:true
  const getFloorsByRack = (floors: any[]) => {
    const byRack: { [rackId: string]: { start: any[]; end: any[] } } = {};
    floors.forEach((floor) => {
      // Support both camelCase and snake_case field names from API response
      const rackId = floor.whRackId || floor.wh_rack_id;
      if (!rackId) return;
      if (!byRack[rackId]) {
        byRack[rackId] = { start: [], end: [] };
      }
      if (floor.position?.toLowerCase() === "end") {
        byRack[rackId].end.push(floor);
      } else {
        // Default to start if position is "Start" or not set
        byRack[rackId].start.push(floor);
      }
    });
    return byRack;
  };

  const floorsByRow = useMemo(
    () => getFloorsByRow(floorList || [], shelveRows || []),
    [floorList, shelveRows],
  );

  const floorsByRack = useMemo(
    () => getFloorsByRack(floorList || []),
    [floorList],
  );

  const selectedFloorParentRow = useMemo(() => {
    if (!selectedFloor || !shelveRows) return null;
    return shelveRows.find(
      (row: any) =>
        floorsByRow[row.id]?.some((f: any) => f.id === selectedFloor.id) ||
        row.rack?.some(
          (rack: any) =>
            floorsByRack[rack.id]?.start?.some(
              (f: any) => f.id === selectedFloor.id,
            ) ||
            floorsByRack[rack.id]?.end?.some(
              (f: any) => f.id === selectedFloor.id,
            ),
        ),
    );
  }, [selectedFloor, shelveRows, floorsByRow, floorsByRack]);

  const selectedFloorParentRack = useMemo(() => {
    if (!selectedFloor || !shelveRows) return null;
    return shelveRows
      .flatMap((row: any) => row.rack || [])
      .find(
        (rack: any) =>
          floorsByRack[rack.id]?.start?.some(
            (f: any) => f.id === selectedFloor.id,
          ) ||
          floorsByRack[rack.id]?.end?.some(
            (f: any) => f.id === selectedFloor.id,
          ),
      );
  }, [selectedFloor, shelveRows, floorsByRack]);

  const getFloorInventory = (floor: any): number => {
    if (!floor || !floor.pallet) return 0;
    return floor.pallet.reduce(
      (sum: number, p: any) => sum + (p.currentInventoryCount || 0),
      0,
    );
  };

  const getLevelInventory = (level: any): number => {
    if (!level) return 0;
    const binSum = (level.bin || []).reduce(
      (sum: number, b: any) => sum + (b.currentInventoryCount || 0),
      0,
    );
    const palletSum = (level.pallet || []).reduce(
      (sum: number, p: any) => sum + (p.currentInventoryCount || 0),
      0,
    );
    return binSum + palletSum + (level.currentInventoryCount || 0);
  };

  const getRackInventory = (rack: any): number => {
    if (!rack || !rack.level) return 0;
    return rack.level.reduce(
      (sum: number, lvl: any) => sum + getLevelInventory(lvl),
      0,
    );
  };

  const getRowInventory = (row: any): number => {
    if (!row) return 0;
    const racksSum = (row.rack || []).reduce(
      (sum: number, r: any) => sum + getRackInventory(r),
      0,
    );
    let floorsSum = 0;
    const rowFloors = floorsByRow[row.id] || [];
    floorsSum += rowFloors.reduce(
      (sum: number, f: any) => sum + getFloorInventory(f),
      0,
    );
    (row.rack || []).forEach((rack: any) => {
      const startFloors = floorsByRack[rack.id]?.start || [];
      const endFloors = floorsByRack[rack.id]?.end || [];
      floorsSum += startFloors.reduce(
        (sum: number, f: any) => sum + getFloorInventory(f),
        0,
      );
      floorsSum += endFloors.reduce(
        (sum: number, f: any) => sum + getFloorInventory(f),
        0,
      );
    });
    return racksSum + floorsSum;
  };

  // Handlers
  const handleCreateShelve = (formData: any) => {
    const payload = {
      warehouseId: selectedWarehouseId,
      ...formData,
    };
    mutate(payload, {
      onSuccess: () => {
        setModal(false);
        fetchShelves();
        setArea(shelves?.[0]?.name ?? "");
      },
      onError: (error) => toast.error(`${error}`),
    });
  };

  const handleCreateRow = (formData: any) => {
    if (!selectedWarehouseId || !currentAreaId) {
      toast.error("Warehouse and Area must be selected");
      return;
    }

    createRow(
      {
        name: formData.name,
        rowNumbers: formData.rowNumbers,
        warehouseId: selectedWarehouseId,
        whAreaId: currentAreaId,
      },
      {
        onSuccess: () => {
          setRow(false);
          refetchShelveRows();
          refetchFloorList();
          rowReset();
          toast.success("Row created successfully");
        },
        onError: (error: any) => {
          toast.error(`Failed to create row: ${error.message}`);
        },
      },
    );
  };

  const handleCreateRackLevel = (formData: any) => {
    if (!selectedRow) {
      toast.error("Please select a row first");
      return;
    }

    const storageType =
      formData.storageType ||
      (selectedArea?.storageType === "B2C" ? "Shelves" : "Bins");

    const payload = {
      ...formData,
      whAreaId: currentAreaId,
      whRowId: selectedRow.id,
      storageType,
    };

    rowMutate(payload, {
      onSuccess: () => {
        toast.success("Rack/Level created successfully");
        setRackLevelModal(false);
        rowReset();
        refetchShelveRows();
        refetchFloorList();
      },
      onError: (error) => toast.error(`${error}`),
    });
  };

  const handleEditRack = (formData: any) => {
    const parentRow = selectedRow || selectedRackParentRow;
    if (!selectedRack || !parentRow) {
      toast.error("Rack and parent Row must be determined");
      return;
    }
    const payload = {
      whAreaId: currentAreaId,
      whRowId: parentRow.id,
      whRackId: selectedRack.id,
      name: formData.rackName || selectedRack.name,
      levels:
        formData.levels?.map((level: any, index: number) => ({
          id: selectedRack.level?.[index]?.id || level.id,
          name: level.name || selectedRack.level?.[index]?.name,
          levelNumber:
            level.levelNumber ||
            selectedRack.level?.[index]?.levelNumber ||
            index + 1,
        })) ||
        selectedRack.level ||
        [],
    };

    updateRack(payload, {
      onSuccess: () => {
        toast.success("Rack updated successfully");
        setEditRackModalOpen(false);
        refetchShelveRows();
        refetchFloorList();
      },
      onError: (error: any) => toast.error(`${error}`),
    });
  };

  const handleDownload = async () => {
    if (!selectedWarehouseId || !currentAreaId) {
      toast.error("Please select a valid Warehouse and Area");
      return;
    }

    const res = await fetchBarcode({
      warehouseId: selectedWarehouseId,
      shelveId: currentAreaId,
    });
    if (res?.pdfUrl) {
      window.open(res.pdfUrl, "_blank");
    } else {
      toast.error("Failed to download barcode PDF");
    }
  };

  // Determine which action buttons are enabled
  const isCreateAreaEnabled = !!selectedWarehouse;
  const isCreateRowEnabled = !!selectedArea;
  const isRackLevelEnabled = !!selectedRow && selectedRow.status !== "INACTIVE";

  const rowFloors = selectedRow ? floorsByRow[selectedRow.id] || [] : [];
  const racks = selectedRow ? selectedRow.rack || [] : [];

  const rowFloorBlocked = selectedRow
    ? rowFloors.length > 0 ||
      (() => {
        const firstRack = racks[0];
        return firstRack
          ? (floorsByRack[firstRack.id]?.start?.length ?? 0) > 0
          : false;
      })()
    : false;

  const anyValidRackSlot = selectedRow
    ? racks.some((rack: any, index: number) => {
        const startBlocked =
          (floorsByRack[rack.id]?.start?.length ?? 0) > 0 ||
          (() => {
            if (index === 0) {
              return rowFloors.length > 0;
            } else {
              const prevRack = racks[index - 1];
              return (floorsByRack[prevRack.id]?.end?.length ?? 0) > 0;
            }
          })();

        const endBlocked =
          (floorsByRack[rack.id]?.end?.length ?? 0) > 0 ||
          (() => {
            if (index < racks.length - 1) {
              const nextRack = racks[index + 1];
              return (floorsByRack[nextRack.id]?.start?.length ?? 0) > 0;
            }
            return false;
          })();

        return !startBlocked || !endBlocked;
      })
    : false;

  const isFloorEnabled =
    !!selectedRow && (!rowFloorBlocked || anyValidRackSlot);

  // Render Heatmap or Inventory based on activeView
  const renderContent = (isMerged?: boolean) => {
    if (!selectedWarehouse) {
      return isMerged ? (
        <div className="bg-[repeating-linear-gradient(45deg,_rgb(248,250,252),_rgb(248,250,252)_10px,_rgb(255,255,255)_10px,_rgb(255,255,255)_20px)] w-full">
          <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn text-center">
            <img
              src="/img/scan-data.png"
              alt="scan prompt"
              className="w-48 opacity-80"
            />
            <div className="text-center max-w-sm">
              <h2 className="text-[#212121] text-lg font-medium">
                🏢 <T>Select a Warehouse</T>
              </h2>
              <p className="text-[#212121]/70 text-sm mt-1">
                <T>Please select a warehouse from the options above to view its layout and inventory.</T>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-1 rounded-3xl border border-slate-200 shadow-sm bg-[repeating-linear-gradient(45deg,_rgb(248,250,252),_rgb(248,250,252)_10px,_rgb(255,255,255)_10px,_rgb(255,255,255)_20px)] hover:shadow-md transition-shadow">
          <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn text-center">
            <img
              src="/img/scan-data.png"
              alt="scan prompt"
              className="w-48 opacity-80"
            />
            <div className="text-center max-w-sm">
              <h2 className="text-[#212121] text-lg font-medium">
                🏢 <T>Select a Warehouse</T>
              </h2>
              <p className="text-[#212121]/70 text-sm mt-1">
                <T>Please select a warehouse from the options above to view its layout and inventory.</T>
              </p>
            </div>
          </div>
        </div>
      );
    }

    if (activeView === "inventory") {
      return (
        <div className="mt-1">
          <InventoryTabMain
            warehouseId={selectedWarehouseId}
            activeOuter={inventoryActiveTab}
            setActiveOuter={setInventoryActiveTab}
            activeInner={inventoryActiveSubTab}
            setActiveInner={setInventoryActiveSubTab}
            searchQuery={searchFor}
          />
        </div>
      );
    }

    const hasSidebarContent =
      !!showShelveSkuModal ||
      !!showActions ||
      !!selectedLocation ||
      !!row ||
      !!modal ||
      !!rackLevelModal ||
      !!floorModal ||
      !!editRackModalOpen ||
      !!binModalOpen ||
      !!palletModalOpen ||
      !!editRowNameModal?.open ||
      !!rowArchiveConfirmModal?.open ||
      !!rackArchiveConfirmModal?.open ||
      !!levelArchiveConfirmModal?.open ||
      !!floorArchiveConfirmModal?.open;
    const hasActiveContext = !!selectedRow || !!selectedRack || !!selectedFloor || !!selectedLevel;

    // Heatmap view
    return (
      <div className={`grid grid-cols-1 ${hasSidebarContent ? (showShelveSkuModal ? "xl:grid-cols-[minmax(0,1fr)_40%]" : "xl:grid-cols-[minmax(0,1fr)_380px]") : "w-full"} ${hasSidebarContent ? "divide-y xl:divide-y-0 xl:divide-x divide-slate-200" : ""}`}>
        {/* Enhanced Warehouse Map Section */}
        <div className="bg-[repeating-linear-gradient(45deg,_rgb(248,250,252),_rgb(248,250,252)_10px,_rgb(255,255,255)_10px,_rgb(255,255,255)_20px)] flex flex-col h-full">
          <div className="flex flex-col gap-3 p-4 bg-white border-b border-slate-200">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2">
                  <span><T>Warehouse Layout Map</T></span>
                </h3>
                <p className="text-sm text-slate-500">
                  <T>Double-click elements for control options. Click any bin, pallet, or shipment to view contents.</T>
                </p>
              </div>
              {/* Mini Map Legend */}
              <div className="flex items-center gap-3 text-[10px] text-slate-500">
                <div className="flex items-center gap-1">
                  <span className="w-3 h-3 rounded bg-amber-100 border border-amber-300"></span>
                  <span><T>Empty</T></span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="w-3 h-3 rounded bg-zinc-300 border border-zinc-400"></span>
                  <span><T>Archived</T></span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="w-3 h-3 rounded bg-green-400 border border-green-300"></span>
                  <span><T>Occupied</T></span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 text-xs font-medium">
              {shelves?.map((shelf: any) => (
                <button
                  key={shelf.id}
                  onClick={() => {
                    setArea(shelf.name);
                    setSelectedRow(null);
                    setSelectedRack(null);
                    setShowActions(false);
                  }}
                  onDoubleClick={() => {
                    if (!canUpdateShelves) return;
                    setArea(shelf.name);
                    setSelectedRow(null);
                    setSelectedRack(null);
                    setShowActions(true);
                  }}
                  className={`rounded-full px-3 py-1.5 transition-all duration-200 ${
                    area === shelf.name
                      ? "bg-[#FBD037] text-[#212121] shadow-md transform scale-105"
                      : "bg-slate-100 text-slate-600 hover:bg-slate-200 hover:scale-105"
                  }`}
                >
                  {shelf.name}
                </button>
              ))}
            </div>
          </div>

          {!area || area === "" ? (
            <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn text-center">
              <img
                src="/img/scan-data.png"
                alt="scan prompt"
                className="w-48 opacity-80"
              />
              <div className="text-center max-w-sm">
                <h2 className="text-[#212121] text-lg font-medium">
                  🗺️ <T>Select an Area</T>
                </h2>
                <p className="text-[#212121]/70 text-sm mt-1">
                  <T>Please select an area from the options above to view its layout and inventory.</T>
                </p>
              </div>
            </div>
          ) : !shelves || shelves.length === 0 ? (
            <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn">
              <img
                src="/img/scan-data.png"
                alt="scan prompt"
                className="w-48 opacity-80"
              />
              <div className="text-center max-w-sm">
                <h2 className="text-[#212121] text-lg font-medium">
                  🚀 <T>Create Zone & Area</T>
                </h2>
                <p className="text-[#212121]/70 text-sm mt-1">
                  <T>You don't have any Area yet. Create one using the button above.</T>
                </p>
              </div>
              {canCreateShelves ? (
                <button
                  onClick={() => setModal(true)}
                  className="flex items-center gap-2 py-2.5 px-6 text-sm rounded-full text-[#212121] bg-[#FBD037] font-medium hover:bg-yellow-400 transition transform hover:scale-105 shadow-md hover:shadow-lg"
                >
                  <IconPlus stroke={1.5} size={20} /> <T>Create Area</T>
                </button>
              ) : (
                <p className="text-xs text-slate-400 font-semibold italic mt-2">
                  <T>(You do not have permission to create areas)</T>
                </p>
              )}
            </div>
          ) : shelveRows?.length === 0 ? (
            <div className="p-8 flex flex-col items-center space-y-6 animate-fadeIn">
              <img
                src="/img/scan-data.png"
                alt="scan prompt"
                className="w-48 opacity-80"
              />
              <div className="text-center max-w-sm">
                <h2 className="text-[#212121] text-lg font-medium">
                  📦 <T>Add Rows</T>
                </h2>
                <p className="text-[#212121]/70 text-sm mt-1">
                  <T>You don't have any Rows yet. Create one.</T>
                </p>
              </div>
              {/* {canCreateShelves ? (
                <button
                  onClick={() => {
                    setRow(true);
                  }}
                  className="flex items-center gap-2 py-2.5 px-6 text-sm rounded-full text-[#212121] bg-[#FBD037] font-medium hover:bg-yellow-400 transition transform hover:scale-105 shadow-md hover:shadow-lg"
                >
                  <IconPlus stroke={1.5} size={20} /> Create Row
                </button>
              ) : (
                <p className="text-xs text-slate-400 font-semibold italic mt-2">
                  (You do not have permission to create rows)
                </p>
              )} */}
            </div>
          ) : (
            <div className="flex flex-row gap-4 overflow-x-auto overflow-y-auto min-h-[400px] p-4 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent">
              {(() => {
                const items: Array<{
                  type: "row" | "floor";
                  data: any;
                  key: string;
                }> = [];

                shelveRows?.forEach((row: any) => {
                  items.push({ type: "row", data: row, key: `row-${row.id}` });
                });

                if (
                  floorsByRow["last_row"] &&
                  floorsByRow["last_row"].length > 0
                ) {
                  floorsByRow["last_row"].forEach((floor: any) => {
                    items.push({
                      type: "floor",
                      data: floor,
                      key: `floor-last-${floor.id}`,
                    });
                  });
                }

                return items.map((item) => {
                  if (item.type === "row") {
                    const row = item.data;
                    return (
                      <div
                        key={item.key}
                        onClick={() => {
                          setSelectedRow(row);
                          setSelectedRack(null);
                          setShowActions(false);
                        }}
                        onDoubleClick={() => {
                          if (!canUpdateShelves) return;
                          setSelectedRow(row);
                          setSelectedRack(null);
                          setShowActions(true);
                        }}
                        className={`w-80 shrink-0 rounded-2xl border p-3 cursor-pointer transition-all duration-300 ${
                          row.status === "INACTIVE"
                            ? "opacity-50 grayscale"
                            : "hover:shadow-xl hover:-translate-y-1"
                        } ${
                          selectedRow?.id === row.id
                            ? "border-[#FBD037] bg-yellow-50 shadow-lg ring-2 ring-yellow-300/50"
                            : "border-slate-200 bg-white hover:shadow-md"
                        }`}
                      >
                        <div className="mb-3 border-b border-slate-200 pb-3">
                          <div className="flex justify-between items-start">
                            <div>
                              <div className="text-sm font-semibold text-slate-900 flex items-center gap-2">
                                {row.name}
                              </div>
                              <div className="text-xs text-slate-500 mt-0.5"><T>Rack Row</T></div>
                            </div>
                            <div className="flex flex-col items-end gap-1.5">
                              {row.status === "INACTIVE" && (
                                <span className="px-2 py-0.5 rounded text-[9px] font-bold uppercase bg-gray-200 text-gray-600 flex items-center gap-1">
                                  <span className="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
                                  <T>Archived</T>
                                </span>
                              )}
                              {/* Row Stats */}
                              <div className="flex gap-1.5 text-[10px]">
                                <span className="bg-slate-100 px-1.5 py-0.5 rounded shrink-0 flex items-center gap-1">
                                  🏷️ {row.rack?.length || 0} <T>Racks</T>
                                </span>
                                <span className="bg-slate-100 px-1.5 py-0.5 rounded shrink-0 flex items-center gap-1">
                                  📦 {getRowInventory(row)} <T>Items</T>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-3 max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
                          {floorsByRow[row.id]?.map((floor: any) => (
                            <div key={`rowfloor-${floor.id}`}>
                              <FloorElement
                                floorId={floor.id}
                                floorName={floor.name}
                                floor={floor}
                                slots={(floor.pallet || []).filter((p: any) => filterItem(p, activeFilter))}
                                fetchShelves={() => {
                                  refetchFloorList();
                                  refetchShelveRows();
                                }}
                                warehouseId={selectedWarehouseId}
                                clientId={selectedWarehouse?.clientId}
                                areaId={currentAreaId}
                                isParentRowArchived={row.status === "INACTIVE"}
                                onClick={() => {
                                  setSelectedFloor(floor);
                                  setShowActions(false);
                                }}
                                onDoubleClick={() => {
                                  if (!canUpdateShelves) return;
                                  setSelectedFloor(floor);
                                  setShowActions(true);
                                }}
                                isSelected={selectedFloor?.id === floor.id}
                                onPalletClick={(pallet) =>
                                  handleSelectLocation({
                                    item: pallet,
                                    type: "pallet",
                                    row,
                                    floor,
                                  })
                                }
                              />
                            </div>
                          ))}
                          {row.rack?.map((rack: any, rackIndex: number) => (
                            <Fragment key={rack.id}>
                              {floorsByRack[rack.id]?.start?.map(
                                (floor: any) => (
                                  <div
                                    key={`rackfloor-start-${floor.id}`}
                                    className="mb-2"
                                  >
                                    <FloorElement
                                      floorId={floor.id}
                                      floorName={floor.name}
                                      floor={floor}
                                      slots={(floor.pallet || []).filter((p: any) => filterItem(p, activeFilter))}
                                      fetchShelves={() => {
                                        refetchFloorList();
                                        refetchShelveRows();
                                      }}
                                      warehouseId={selectedWarehouseId}
                                      clientId={selectedWarehouse?.clientId}
                                      areaId={currentAreaId}
                                      isParentRowArchived={
                                        row.status === "INACTIVE"
                                      }
                                      onClick={() => {
                                        setSelectedFloor(floor);
                                        setShowActions(false);
                                      }}
                                      onDoubleClick={() => {
                                        if (!canUpdateShelves) return;
                                        setSelectedFloor(floor);
                                        setShowActions(true);
                                      }}
                                      isSelected={
                                        selectedFloor?.id === floor.id
                                      }
                                      onPalletClick={(pallet) =>
                                        handleSelectLocation({
                                          item: pallet,
                                          type: "pallet",
                                          row,
                                          rack,
                                          floor,
                                        })
                                      }
                                    />
                                  </div>
                                ),
                              )}

                              {/* Enhanced Rack card */}
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedRack(rack);
                                  setShowActions(false);
                                }}
                                onDoubleClick={(e) => {
                                  e.stopPropagation();
                                  if (!canUpdateShelves) return;
                                  setSelectedRack(rack);
                                  setShowActions(true);
                                }}
                                className={`rounded-2xl border border-dashed p-3 cursor-pointer transition-all duration-300 ${
                                  rack.status === "INACTIVE"
                                    ? "opacity-50 grayscale"
                                    : "hover:shadow-md"
                                } ${
                                  selectedRack?.id === rack.id
                                    ? "bg-yellow-50 border-yellow-300 ring-2 ring-yellow-300/30"
                                    : "bg-slate-50 border-slate-200 hover:bg-slate-100"
                                }`}
                              >
                                <div className="flex justify-between items-center mb-2">
                                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 flex items-center gap-1.5">
                                    {rack.name}
                                    {/* <span className="text-[8px] text-slate-300 font-normal">
                                      #{rack.id?.slice(0, 4)}
                                    </span> */}
                                  </div>
                                  {rack.status === "INACTIVE" && (
                                    <span className="px-2 py-0.5 rounded text-[9px] font-bold uppercase bg-gray-200 text-gray-600">
                                      <T>Archived</T>
                                    </span>
                                  )}
                                </div>
                                {rack.level && rack.level.length > 0 ? (
                                  <div className="flex flex-col gap-3">
                                    {rack.level.map(
                                      (level: any, idx: number) => (
                                        <div
                                          key={level.id}
                                          className="relative"
                                        >
                                          {/* Level Indicator */}
                                          <div className="absolute -left-2 top-1/2 -translate-y-1/2 w-1 h-6 bg-gradient-to-b from-blue-400 to-purple-400 rounded-full opacity-50"></div>
                                          <RackLevelElement
                                            key={level.id}
                                            rackLevelId={level.id}
                                            rackLevelName={level.name}
                                            rackLevel={{
                                               ...level,
                                               bin: (level.bin || []).filter((b: any) => filterItem(b, activeFilter)),
                                               pallet: (level.pallet || []).filter((p: any) => filterItem(p, activeFilter))
                                             }}
                                            pallets={(level.pallet || []).filter((p: any) => filterItem(p, activeFilter))}
                                            bins={(level.bin || []).filter((b: any) => filterItem(b, activeFilter))}
                                            fetchShelves={() => {
                                              refetchShelveRows();
                                              refetchFloorList();
                                            }}
                                            isParentRowArchived={
                                              row.status === "INACTIVE" ||
                                              rack.status === "INACTIVE"
                                            }
                                            onItemClick={(item, type) =>
                                              handleSelectLocation({
                                                item,
                                                type,
                                                row,
                                                rack,
                                                level,
                                              })
                                            }
                                            onClick={() => {
                                              setSelectedLevel(level);
                                              setShowActions(false);
                                            }}
                                            onDoubleClick={() => {
                                              if (!canUpdateShelves) return;
                                              setSelectedLevel(level);
                                              setShowActions(true);
                                            }}
                                            isSelected={
                                              selectedLevel?.id === level.id
                                            }
                                          />
                                          {/* Level Divider */}
                                          {idx < rack.level.length - 1 && (
                                            <div className="w-full h-px bg-slate-200 my-1"></div>
                                          )}
                                        </div>
                                      ),
                                    )}
                                  </div>
                                ) : (
                                  <div className="rounded-xl border border-dashed border-slate-200 px-3 py-6 text-center text-xs text-slate-400 hover:border-slate-300 transition-colors">
                                    <span className="block text-2xl mb-1">
                                      📋
                                    </span>
                                    <T>No levels configured</T>
                                  </div>
                                )}
                              </div>

                              {floorsByRack[rack.id]?.end?.map((floor: any) => (
                                <div
                                  key={`rackfloor-end-${floor.id}`}
                                  className="mt-2"
                                >
                                  <FloorElement
                                    floorId={floor.id}
                                    floorName={floor.name}
                                    floor={floor}
                                    slots={(floor.pallet || []).filter((p: any) => filterItem(p, activeFilter))}
                                    fetchShelves={() => {
                                      refetchFloorList();
                                      refetchShelveRows();
                                    }}
                                    warehouseId={selectedWarehouseId}
                                    clientId={selectedWarehouse?.clientId}
                                    areaId={currentAreaId}
                                    isParentRowArchived={
                                      row.status === "INACTIVE"
                                    }
                                    onClick={() => {
                                      setSelectedFloor(floor);
                                      setShowActions(false);
                                    }}
                                    onDoubleClick={() => {
                                      if (!canUpdateShelves) return;
                                      setSelectedFloor(floor);
                                      setShowActions(true);
                                    }}
                                    isSelected={selectedFloor?.id === floor.id}
                                    onPalletClick={(pallet) =>
                                      handleSelectLocation({
                                        item: pallet,
                                        type: "pallet",
                                        row,
                                        rack,
                                        floor,
                                      })
                                    }
                                  />
                                </div>
                              ))}
                            </Fragment>
                          ))}
                        </div>
                      </div>
                    );
                  } else {
                    const floor = item.data;
                    return (
                      <div key={item.key} className="w-80 shrink-0">
                        <FloorElement
                          floorId={floor.id}
                          floorName={floor.name}
                          floor={floor}
                          slots={(floor.pallet || []).filter((p: any) => filterItem(p, activeFilter))}
                          fetchShelves={() => {
                            refetchFloorList();
                            refetchShelveRows();
                          }}
                          warehouseId={selectedWarehouseId}
                          clientId={selectedWarehouse?.clientId}
                          areaId={currentAreaId}
                          onClick={() => {
                            setSelectedFloor(floor);
                            setShowActions(false);
                          }}
                          onDoubleClick={() => {
                            if (!canUpdateShelves) return;
                            setSelectedFloor(floor);
                            setShowActions(true);
                          }}
                          isSelected={selectedFloor?.id === floor.id}
                          onPalletClick={(pallet) =>
                            handleSelectLocation({
                              item: pallet,
                              type: "pallet",
                              floor,
                            })
                          }
                        />
                      </div>
                    );
                  }
                });
              })()}
            </div>
          )}
        </div>

        {/* Enhanced Side Panel */}
        {hasSidebarContent && (
          <div className="bg-white flex flex-col h-full divide-y divide-slate-200">
          {showShelveSkuModal ? (         
            <InteractiveShelvingOperatorPortal
              onClose={() => setShowShelveSkuModal(false)}
              warehouseId={selectedWarehouseId}
              onSuccess={() => {
                refetchFloorList();
                refetchShelveRows();
              }}
            />
          ) : selectedWarehouse ? (
            <>
              {!selectedLocation && showActions && (
                <div className="p-4 flex flex-col">
                  {canCreateShelves && !hasActiveContext && (
                    <>
                      <div className="mb-3 flex items-center justify-between">
                        <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-2">
                          <T>Operational Quick Actions</T>
                        </h3>
                        <span className="rounded-full bg-gradient-to-r from-blue-50 to-indigo-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-blue-700 border border-blue-100">
                          {selectedRow ? `${t("Active")}: ${selectedRow.name}` : t("Actions")}
                        </span>
                      </div>

                      {/* Enhanced Action Grid */}
                      <div className="grid grid-cols-2 gap-2 mb-4">
                        <button
                          onClick={() => {
                            setModal(true);
                            setRow(false);
                            setRackLevelModal(false);
                            setFloorModal(false);
                            setEditRackModalOpen(false);
                            rowReset();
                          }}
                          disabled={!isCreateAreaEnabled}
                          className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
                            isCreateAreaEnabled
                              ? "bg-[#212121] text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
                              : "bg-gray-200 text-gray-500 cursor-not-allowed"
                          }`}
                        >
                          <span className="flex items-center justify-center gap-1.5">
                            <span>🏗️</span> <T>Create Area</T>
                          </span>
                        </button>

                        <button
                          onClick={() => {
                            setRow(true);
                            setModal(false);
                            setRackLevelModal(false);
                            setFloorModal(false);
                            setEditRackModalOpen(false);
                            rowReset();
                          }}
                          disabled={!isCreateRowEnabled}
                          className={`w-full rounded-xl px-3 py-2.5 transition-all duration-200 text-sm font-medium ${
                            isCreateRowEnabled
                              ? "bg-[#212121] text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
                              : "bg-gray-200 text-gray-500 cursor-not-allowed"
                          }`}
                        >
                          <span className="flex items-center justify-center gap-1.5">
                            <span>📋</span> <T>Create Row</T>
                          </span>
                        </button>
                      </div>
                    </>
                  )}

              {/* Enhanced Contextual Actions */}
              {selectedRack &&
                (() => {
                  const isRackActionsDisabled =
                    (selectedRackParentRow as any)?.status === "INACTIVE";
                  return (
                    <div className="animate-slideDown">
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
                        <span className="text-blue-500">▸</span>
                        {t("Rack Actions")}: {[
                          selectedArea?.name,
                          selectedRackParentRow?.name,
                          selectedRack.name,
                        ]
                          .filter(Boolean)
                          .join("-")}
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {canCreateShelves && selectedRack.status !== "INACTIVE" && (
                          <button
                            onClick={() => {
                              if (isRackActionsDisabled) {
                                toast.error(
                                  "Parent row is archived. Please restore it first.",
                                );
                                return;
                              }
                              setEditRackModalOpen(true);
                              setModal(false);
                              setRow(false);
                              setRackLevelModal(false);
                              setFloorModal(false);
                            }}
                            disabled={isRackActionsDisabled}
                            className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
                              isRackActionsDisabled
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : "bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>➕</span> <T>Add Levels</T>
                            </span>
                          </button>
                        )}
                        {canUpdateShelves && (
                          <button
                            onClick={() => {
                              if (isRackActionsDisabled) {
                                toast.error(
                                  "Parent row is archived. Please restore it first.",
                                );
                                return;
                              }
                              const isInactive =
                                selectedRack.status === "INACTIVE";
                              setRackArchiveConfirmModal({
                                open: true,
                                rack: selectedRack,
                                action: isInactive ? "restore" : "archive",
                              });
                            }}
                            disabled={
                              isRackActionsDisabled ||
                              (selectedRack.status !== "INACTIVE" &&
                                getRackInventory(selectedRack) > 0)
                            }
                            title={
                              selectedRack.status !== "INACTIVE" &&
                              getRackInventory(selectedRack) > 0
                                ? `${t("cannot archive rack with active inventory")} (${getRackInventory(selectedRack)} ${t("items stored")})`
                                : ""
                            }
                            className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
                              isRackActionsDisabled ||
                              (selectedRack.status !== "INACTIVE" &&
                                getRackInventory(selectedRack) > 0)
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : selectedRack.status === "INACTIVE"
                                  ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                                  : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>
                                {selectedRack.status === "INACTIVE" ? "♻️" : "🗑️"}
                              </span>
                              {selectedRack.status === "INACTIVE"
                                ? t("Restore")
                                : t("Archive")}
                            </span>
                          </button>
                        )}
                      </div>
                      {/* Rack Inventory Summary */}
                      {selectedRack.status !== "INACTIVE" && (
                        <div className="mt-2 p-2 bg-slate-50 rounded-lg text-[10px] text-slate-500">
                          <span className="font-medium">{t("Inventory")}:</span>{" "}
                          {getRackInventory(selectedRack)} {t("items across")}{" "}
                          {selectedRack.level?.length || 0} {t("levels")}
                        </div>
                      )}
                    </div>
                  );
                })()}

              {selectedRow &&
                !selectedRack &&
                (() => {
                  const rowInventory = getRowInventory(selectedRow);
                  const isArchiveDisabled =
                    selectedRow.status !== "INACTIVE" && rowInventory > 0;
                  return (
                    <div className="animate-slideDown">
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
                        <span className="text-amber-500">▸</span>
                        {t("Row Actions")}: {[selectedArea?.name, selectedRow.name]
                          .filter(Boolean)
                          .join("-")}
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {canCreateShelves && (
                          <button
                            onClick={() => {
                              if (selectedRow) {
                                setRackLevelModal(true);
                                setModal(false);
                                setRow(false);
                                setFloorModal(false);
                                setEditRackModalOpen(false);
                                rowReset();
                              } else {
                                toast.error("Please select a row first");
                              }
                            }}
                            disabled={!isRackLevelEnabled}
                            className={`w-full rounded-xl px-3 py-2 transition-all duration-200 text-sm font-medium ${
                              isRackLevelEnabled
                                ? "bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
                                : "bg-gray-200 text-gray-500 cursor-not-allowed"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>📦</span> <T>Rack Level</T>
                            </span>
                          </button>
                        )}

                        {canCreateShelves && (
                          <button
                            onClick={() => {
                              if (!selectedRow) {
                                toast.error("Please select a row first");
                              } else if (!isFloorEnabled) {
                                toast.error(
                                  "All available floor positions in this row are occupied or blocked by consecutive floor constraints.",
                                );
                              } else {
                                setFloorModal(true);
                                setModal(false);
                                setRow(false);
                                setRackLevelModal(false);
                                setEditRackModalOpen(false);
                                rowReset();
                              }
                            }}
                            disabled={!isFloorEnabled}
                            title={
                              !isFloorEnabled && selectedRow
                                ? "No available floor slots in this row due to occupancy or consecutive constraints"
                                : ""
                            }
                            className={`w-full rounded-xl px-3 py-2 transition-all duration-200 text-sm font-medium ${
                              isFloorEnabled
                                ? "bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:opacity-90 hover:shadow-lg transform hover:scale-[1.02]"
                                : "bg-gray-200 text-gray-500 cursor-not-allowed"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>🏢</span> <T>Floor</T>
                            </span>
                          </button>
                        )}

                        {canUpdateShelves && (
                          <button
                            onClick={() => {
                              setEditRowNameModal({
                                open: true,
                                row: selectedRow,
                              });
                            }}
                            className="w-full rounded-xl px-3 py-2 text-sm font-medium bg-gradient-to-r from-slate-600 to-slate-700 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02] transition-all"
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>✏️</span> <T>Edit Name</T>
                            </span>
                          </button>
                        )}
                        {canUpdateShelves && (
                          <button
                            onClick={() => {
                              const isInactive =
                                selectedRow.status === "INACTIVE";
                              setRowArchiveConfirmModal({
                                open: true,
                                row: selectedRow,
                                action: isInactive ? "restore" : "archive",
                              });
                            }}
                            disabled={isArchiveDisabled}
                            title={
                              isArchiveDisabled
                                ? `${t("cannot archive row with active inventory")} (${rowInventory} ${t("items stored")})`
                                : ""
                            }
                            className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
                              isArchiveDisabled
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : selectedRow.status === "INACTIVE"
                                  ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                                  : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>
                                {selectedRow.status === "INACTIVE" ? "♻️" : "🗑️"}
                              </span>
                              {selectedRow.status === "INACTIVE"
                                ? t("Restore")
                                : t("Archive")}
                            </span>
                          </button>
                        )}
                      </div>
                      {/* Row Stats */}
                      <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
                        <span className="flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
                          {selectedRow.rack?.filter(
                            (r: any) => r.status !== "INACTIVE",
                          ).length || 0}{" "}
                          <T>Active Racks</T>
                        </span>
                        <span className="flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-slate-400"></span>
                          {selectedRow.rack?.filter(
                            (r: any) => r.status === "INACTIVE",
                          ).length || 0}{" "}
                          <T>Archived</T>
                        </span>
                      </div>
                    </div>
                  );
                })()}

              {selectedFloor &&
                !selectedRack &&
                !selectedRow &&
                (() => {
                  const isFloorParentArchivedOnly =
                    (selectedFloorParentRow as any)?.status === "INACTIVE";
                  const isFloorActionsDisabled =
                    isFloorParentArchivedOnly ||
                    selectedFloor.status === "INACTIVE";

                  return (
                    <div className="animate-slideDown">
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
                        <span className="text-emerald-500">▸</span>
                        {t("Floor Actions")}: {selectedFloor.name}
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {selectedFloor.status !== "INACTIVE" && (
                          <button
                            onClick={() => {
                              if (isFloorActionsDisabled) {
                                toast.error(
                                  "Parent element is archived. Please restore it first.",
                                );
                                return;
                              }
                              setPalletModalOpen(true);
                            }}
                            disabled={isFloorActionsDisabled}
                            className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
                              isFloorActionsDisabled
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : "bg-gradient-to-r from-violet-500 to-purple-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>
                                {selectedFloor.pallet &&
                                selectedFloor.pallet.length > 0
                                  ? "➕"
                                  : "📦"}
                              </span>
                              {selectedFloor.pallet &&
                              selectedFloor.pallet.length > 0
                                ? t("Add More Pallets")
                                : t("Create Pallet")}
                            </span>
                          </button>
                        )}
                        <button
                          onClick={() => {
                            if (isFloorParentArchivedOnly) {
                              toast.error(
                                "Parent element is archived. Please restore it first.",
                              );
                              return;
                            }
                            const isInactive =
                              selectedFloor.status === "INACTIVE";
                            setFloorArchiveConfirmModal({
                              open: true,
                              floor: selectedFloor,
                              action: isInactive ? "restore" : "archive",
                            });
                          }}
                          disabled={
                            isFloorParentArchivedOnly ||
                            (selectedFloor.status !== "INACTIVE" &&
                              getFloorInventory(selectedFloor) > 0)
                          }
                          title={
                            selectedFloor.status !== "INACTIVE" &&
                            getFloorInventory(selectedFloor) > 0
                              ? `${t("cannot archive floor with active inventory")} (${getFloorInventory(selectedFloor)} ${t("items stored")})`
                              : ""
                          }
                          className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
                            isFloorParentArchivedOnly ||
                            (selectedFloor.status !== "INACTIVE" &&
                              getFloorInventory(selectedFloor) > 0)
                              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                              : selectedFloor.status === "INACTIVE"
                                ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                                : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                          }`}
                        >
                          <span className="flex items-center justify-center gap-1">
                            <span>
                              {selectedFloor.status === "INACTIVE"
                                ? "♻️"
                                : "🗑️"}
                            </span>
                            {selectedFloor.status === "INACTIVE"
                              ? t("Restore")
                              : t("Archive")}
                          </span>
                        </button>
                      </div>
                      {/* Floor Stats */}
                      {selectedFloor.status !== "INACTIVE" && (
                        <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
                          <span className="flex items-center gap-1">
                            📦 {selectedFloor.pallet?.length || 0} <T>Pallets</T>
                          </span>
                          <span className="flex items-center gap-1">
                            📊 {getFloorInventory(selectedFloor)} <T>Items</T>
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })()}

              {selectedLevel &&
                !selectedRack &&
                !selectedRow &&
                !selectedFloor &&
                (() => {
                  const hasBins =
                    selectedLevel.bin && selectedLevel.bin.length > 0;
                  const hasPallets =
                    selectedLevel.pallet && selectedLevel.pallet.length > 0;
                  const isLevelParentArchived =
                    selectedLevelParentRack?.status === "INACTIVE" ||
                    (selectedLevelParentRow as any)?.status === "INACTIVE";
                  const isLevelAddDisabled =
                    isLevelParentArchived ||
                    selectedLevel.status === "INACTIVE";

                  return (
                    <div className="animate-slideDown">
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 flex items-center gap-1.5">
                        <span className="text-indigo-500">▸</span>
                        {t("Level Actions")}: {[
                          selectedArea?.name,
                          selectedLevelParentRow?.name,
                          selectedLevelParentRack?.name,
                          selectedLevel?.name,
                        ]
                          .filter(Boolean)
                          .join("-")}
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {selectedLevel.status !== "INACTIVE" && !hasPallets && (
                          <button
                            onClick={() => {
                              if (isLevelAddDisabled) {
                                toast.error(
                                  "Parent elements are archived. Please restore them first.",
                                );
                                return;
                              }
                              setPreselectedType("bins");
                              setBinModalOpen(true);
                            }}
                            disabled={isLevelAddDisabled}
                            className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
                              isLevelAddDisabled
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : "bg-gradient-to-r from-indigo-500 to-blue-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>{hasBins ? "➕" : "📦"}</span>
                              {hasBins ? t("Add More Bins") : t("Create Bin")}
                            </span>
                          </button>
                        )}
                        {selectedLevel.status !== "INACTIVE" && !hasBins && !(selectedLevel.currentInventoryCount > 0) && (
                          <button
                            onClick={() => {
                              if (isLevelAddDisabled) {
                                toast.error(
                                  "Parent elements are archived. Please restore them first.",
                                );
                                return;
                              }
                              setPreselectedType("pallets");
                              setBinModalOpen(true);
                            }}
                            disabled={isLevelAddDisabled}
                            className={`w-full rounded-xl px-3 py-2 text-sm font-medium transition-all ${
                              isLevelAddDisabled
                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                : "bg-gradient-to-r from-violet-500 to-purple-500 text-white hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                            }`}
                          >
                            <span className="flex items-center justify-center gap-1">
                              <span>{hasPallets ? "➕" : "📦"}</span>
                              {hasPallets
                                ? t("Add More Pallets")
                                : t("Create Pallet")}
                            </span>
                          </button>
                        )}
                        <button
                          onClick={() => {
                            if (isLevelParentArchived) {
                              toast.error(
                                "Parent elements are archived. Please restore them first.",
                              );
                              return;
                            }
                            const isInactive =
                              selectedLevel.status === "INACTIVE";
                            setLevelArchiveConfirmModal({
                              open: true,
                              level: selectedLevel,
                              action: isInactive ? "restore" : "archive",
                            });
                          }}
                          disabled={
                            isLevelParentArchived ||
                            (selectedLevel.status !== "INACTIVE" &&
                              getLevelInventory(selectedLevel) > 0)
                          }
                          title={
                            selectedLevel.status !== "INACTIVE" &&
                            getLevelInventory(selectedLevel) > 0
                              ? `${t("cannot archive level with active inventory")} (${getLevelInventory(selectedLevel)} ${t("items stored")})`
                              : ""
                          }
                          className={`w-full rounded-xl px-3 py-2 text-white text-sm font-medium transition-all ${
                            isLevelParentArchived ||
                            (selectedLevel.status !== "INACTIVE" &&
                              getLevelInventory(selectedLevel) > 0)
                              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                              : selectedLevel.status === "INACTIVE"
                                ? "bg-gradient-to-r from-emerald-500 to-green-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                                : "bg-gradient-to-r from-red-500 to-rose-500 hover:opacity-90 hover:shadow-md transform hover:scale-[1.02]"
                          }`}
                        >
                          <span className="flex items-center justify-center gap-1">
                            <span>
                              {selectedLevel.status === "INACTIVE"
                                ? "♻️"
                                : "🗑️"}
                            </span>
                            {selectedLevel.status === "INACTIVE"
                              ? t("Restore")
                              : t("Archive")}
                          </span>
                        </button>
                      </div>
                      {/* Level Stats */}
                      {selectedLevel.status !== "INACTIVE" && (
                        <div className="mt-2 flex gap-3 text-[10px] text-slate-500">
                          <span className="flex items-center gap-1">
                            📦 {selectedLevel.bin?.length || 0} <T>Bins</T>
                          </span>
                          <span className="flex items-center gap-1">
                            📦 {selectedLevel.pallet?.length || 0} <T>Pallets</T>
                          </span>
                          <span className="flex items-center gap-1">
                            📊 {getLevelInventory(selectedLevel)} <T>Items</T>
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })()}
                </div>
              )}

              {selectedLocation && (
                <div className="p-4 bg-white animate-fadeIn space-y-4">
                  <div className="flex justify-between items-center pb-2 border-b border-slate-100">
                    <div>
                      <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-1.5">
                        <T>Location Control Panel</T>
                      </h3>
                      <p className="text-[10px] font-mono text-slate-400 mt-0.5">
                        {selectedLocation?.item?.barcodeLabel ||
                          selectedLocation?.item?.name ||
                          ""}
                      </p>
                    </div>
                    <button
                      onClick={handleCloseFilter}
                      className="bg-slate-100 hover:bg-slate-200 rounded-full p-1 cursor-pointer transition-colors text-slate-500 hover:text-slate-700"
                      title="Clear Selection"
                    >
                      <IconX size={16} />
                    </button>
                  </div>

                  {/* Location Path */}
                  <div className="border border-slate-200 bg-slate-50/50 p-3 space-y-2 rounded-xl">
                    <h4 className="text-xs font-semibold text-slate-800"><T>Location Path</T></h4>
                    <p className="text-xs flex items-center flex-wrap gap-1">
                      {pathSegments.map((segment: string, index: number) => (
                        <Fragment key={index}>
                          {index > 0 && (
                            <span className="text-slate-400">
                              <IconChevronRight size={12} />
                            </span>
                          )}
                          <span className="font-medium text-slate-700">
                            {segment}
                          </span>
                        </Fragment>
                      ))}
                    </p>
                  </div>

                  {isShipment ? (
                    <div className="border border-slate-200 bg-slate-50/50 p-3 space-y-3 rounded-xl max-h-[300px] overflow-y-auto">
                      <h4 className="text-xs font-semibold text-slate-800 flex items-center justify-between border-b border-slate-200/80 pb-1.5 mb-2">
                        <span><T>Shipment Inventory</T></span>
                        <span className="bg-blue-50 text-blue-700 font-bold px-2.5 py-0.5 rounded text-[10px]">
                          {shipmentLocationInventoryData?.inventoryMovement?.length || 0} <T>Items</T>
                        </span>
                      </h4>
                      <div className="space-y-2">
                        {shipmentLocationInventoryData?.inventoryMovement?.map((c: any, idx: number) => (
                          <div key={c.id || idx} className="bg-white p-2.5 rounded-xl border border-slate-100 flex flex-col space-y-1.5 shadow-sm text-xs">
                            <div className="flex justify-between items-center border-b border-slate-50 pb-1">
                              <span className="font-semibold text-slate-400 uppercase text-[9px] tracking-wider">AWB / AWN</span>
                              <span className="font-mono font-bold text-blue-700 bg-blue-50 px-2 py-0.5 rounded">{c.awb || "N/A"}</span>
                            </div>
                            <div className="flex justify-between items-start">
                              <span className="font-semibold text-slate-400 uppercase text-[9px] tracking-wider">Destination</span>
                              <span className="text-slate-800 font-medium text-right max-w-[150px] truncate" title={c.destination || "N/A"}>
                                {c.destination || "N/A"}
                              </span>
                            </div>
                          </div>
                        ))}
                        {(!shipmentLocationInventoryData?.inventoryMovement || shipmentLocationInventoryData.inventoryMovement.length === 0) && (
                          <div className="text-center py-6 text-slate-400 text-xs">
                            <T>No shipments found</T>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    availableUnits > 0 && (
                      <>
                        <div className="border border-slate-200 bg-slate-50/50 p-3 space-y-1.5 rounded-xl">
                          <h4 className="text-xs font-semibold text-slate-800">
                            <T>Capacity & Allocation</T>
                          </h4>
                          <div className="flex justify-between items-center border-b border-slate-100 py-1">
                            <p className="text-xs text-slate-500"><T>Capacity Cap</T></p>
                            <p className="text-xs font-semibold text-slate-800">{capacityCap}</p>
                          </div>
                          <div className="flex justify-between items-center py-1">
                            <p className="text-xs text-slate-500">
                              {isLocationReserved ? (
                                <T>Reserved Units</T>
                              ) : (
                                <T>Available Units</T>
                              )}
                            </p>
                            <p className="text-xs font-semibold text-slate-800">
                              {isInventoryLoadingFinal ? (
                                <T>Loading...</T>
                              ) : availableUnits ? (
                                availableUnits
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                        </div>
                        
                        <div className="border border-slate-200 bg-slate-50/50 p-3 space-y-1.5 rounded-xl">
                          <h4 className="text-xs font-semibold text-slate-800">
                            <T>Inventory Traceability</T>
                          </h4>
                          <div className="flex justify-between items-center border-b border-slate-100 py-1">
                            <p className="text-xs text-slate-500"><T>Product</T></p>
                            <p
                              className="text-xs font-medium text-slate-700 truncate max-w-[180px]"
                              title={productNames}
                            >
                              {productNames}
                            </p>
                          </div>
                          <div className="flex justify-between items-center border-b border-slate-100 py-1">
                            <p className="text-xs text-slate-500"><T>SKU</T></p>
                            <p className="text-xs font-mono text-slate-700">{skus}</p>
                          </div>
                          <div className="flex justify-between items-center py-1">
                            <p className="text-xs text-slate-500"><T>Expiry</T></p>
                            <p className="text-xs text-slate-700">{expiries}</p>
                          </div>
                        </div>
                      </>
                    )
                  )}

                  {/* Barcodes */}
                  {isShipment ? (
                    <div className="border border-slate-200 bg-slate-50/50 p-3 rounded-xl flex justify-center w-full">
                      <div className="flex flex-col items-center justify-center w-full border border-slate-100 p-2.5 space-y-1 rounded-xl bg-white shadow-sm">
                        {selectedLocation?.item?.barcodeLabel ? (
                          <div className="w-full h-14 flex items-center justify-center p-0.5">
                            <Barcode
                              value={selectedLocation.item.barcodeLabel}
                              height={50}
                              width={1.8}
                              className="w-full h-full max-w-full max-h-full"
                            />
                          </div>
                        ) : selectedLocation?.item?.barcodeUrl ? (
                          <img
                            src={selectedLocation.item.barcodeUrl}
                            alt="location-barcode"
                            className="w-full h-14 object-fill mix-blend-multiply"
                          />
                        ) : (
                          <div className="w-full h-14 flex items-center justify-center text-slate-300 text-xs font-medium">
                            <T>No Barcode</T>
                          </div>
                        )}
                        <p className="text-[9px] font-mono font-bold text-slate-600 uppercase truncate max-w-full">
                          {selectedLocation?.item?.barcodeLabel || ""}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="border border-slate-200 bg-slate-50/50 p-3 rounded-xl flex flex-col gap-2 w-full">
                      <div className="flex flex-col items-center justify-center w-full border border-slate-100 p-2.5 space-y-1 rounded-xl bg-white shadow-sm">
                        {locationInventoryData?.[0]?.barcodeUrl ? (
                          <img
                            src={locationInventoryData[0].barcodeUrl}
                            alt="location-barcode"
                            className="w-full h-14 object-fill mix-blend-multiply"
                          />
                        ) : selectedLocation?.item?.barcodeLabel ? (
                          <div className="w-full h-14 flex items-center justify-center p-0.5">
                            <Barcode
                              value={selectedLocation.item.barcodeLabel}
                              height={50}
                              width={1.8}
                              className="w-full h-full max-w-full max-h-full"
                            />
                          </div>
                        ) : selectedLocation?.item?.barcodeUrl ? (
                          <img
                            src={selectedLocation.item.barcodeUrl}
                            alt="location-barcode"
                            className="w-full h-14 object-fill mix-blend-multiply"
                          />
                        ) : (
                          <div className="w-full h-14 flex items-center justify-center text-slate-300 text-xs font-medium">
                            <T>No Barcode</T>
                          </div>
                        )}
                        {!locationInventoryData?.[0]?.barcodeUrl &&
                          !(
                            !selectedLocation?.item?.barcodeLabel &&
                            selectedLocation?.item?.barcodeUrl
                          ) && (
                            <p className="text-[9px] font-mono font-bold text-slate-600 uppercase truncate max-w-full">
                              {selectedLocation?.item?.barcodeLabel || ""}
                            </p>
                          )}
                      </div>
                      <div className="flex flex-col items-center justify-center w-full border border-slate-100 p-2.5 space-y-1 rounded-xl bg-white shadow-sm">
                        {locationInventoryData?.[0]?.skuBarcodeUrl ? (
                          <img
                            src={locationInventoryData[0].skuBarcodeUrl}
                            alt="sku-barcode"
                            className="w-full h-14 object-fill mix-blend-multiply"
                          />
                        ) : skus && skus !== "" && skus !== "Empty" ? (
                          <div className="w-full h-14 flex items-center justify-center p-0.5">
                            <Barcode
                              value={skus}
                              height={50}
                              width={1.8}
                              className="w-full h-full max-w-full max-h-full"
                            />
                          </div>
                        ) : (
                          <div className="w-full h-14 flex items-center justify-center text-slate-300 text-[10px] font-medium text-center leading-tight">
                            <T>No SKU Barcode</T>
                          </div>
                        )}
                        {!locationInventoryData?.[0]?.skuBarcodeUrl && skus && skus !== "" && skus !== "Empty" && (
                          <p className="text-[9px] font-mono font-bold text-slate-600 uppercase truncate max-w-full">
                            {skus}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Actions Grid */}
                  <div className="grid grid-cols-2 gap-2">
                    {isShipment ? (
                      <button
                        onClick={handlePrintLabel}
                        className="bg-white border border-slate-200 text-slate-700 rounded-xl py-2 px-3 hover:bg-slate-50 transition-all duration-200 text-xs font-semibold"
                      >
                        <T>Print Label</T>
                      </button>
                    ) : (
                      <>
                        {/* <button className="bg-[#212121] text-white rounded-xl py-2 px-3 hover:opacity-90 transition-all duration-200 text-xs font-semibold">
                          Transfer
                        </button>
                        <button className="bg-white border border-slate-200 text-slate-700 rounded-xl py-2 px-3 hover:bg-slate-50 transition-all duration-200 text-xs font-semibold">
                          Reserve
                        </button>
                        <button className="bg-white border border-slate-200 text-slate-700 rounded-xl py-2 px-3 hover:bg-slate-50 transition-all duration-200 text-xs font-semibold">
                          Cycle Count
                        </button>
                        <button className="bg-white border border-slate-200 text-slate-700 rounded-xl py-2 px-3 hover:bg-slate-50 transition-all duration-200 text-xs font-semibold">
                          Block
                        </button> */}
                      <button
                        onClick={handlePrintLabel}
                        className="bg-white border border-slate-200 text-slate-700 rounded-xl py-2 px-3 hover:bg-slate-50 transition-all duration-200 text-xs font-semibold"
                      >
                        <T>Print Label</T>
                      </button>
                        <div className="relative group w-full">
                          <button
                            onClick={() => {
                              if (
                                selectedLocation?.item?.status !== "INACTIVE" &&
                                hasActiveInventory
                              )
                                return;
                              handleToggleLocationStatus();
                            }}
                            className={`w-full rounded-xl py-2 px-3 transition-all text-xs font-semibold ${
                              selectedLocation?.item?.status === "INACTIVE"
                                ? "bg-green-600 text-white hover:opacity-90 cursor-pointer"
                                : hasActiveInventory
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed border-none"
                                  : "bg-red-500 text-white hover:opacity-90 cursor-pointer"
                            }`}
                          >
                            {selectedLocation?.item?.status === "INACTIVE"
                              ? t("Restore")
                              : t("Archive")}
                          </button>
                          {selectedLocation?.item?.status !== "INACTIVE" &&
                            hasActiveInventory && (
                              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block z-[70] pointer-events-none">
                                <div className="whitespace-nowrap rounded-md bg-slate-800 px-3 py-1.5 text-[10px] text-white shadow-lg relative">
                                  <T>Cannot archive with inventory</T>
                                  <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 rotate-45 bg-slate-800 -mt-1"></div>
                                </div>
                              </div>
                            )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : null}
 
          {modal && (
            <CreateZoneAreaModal
              open={modal}
              onClose={() => setModal(false)}
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
              watch={watch}
              isPending={isPending}
              handleSubmit={handleSubmit(handleCreateShelve)}
            />
          )}

          {row && (
            <CreateRowOnlyModal
              open={row}
              modalType="create"
              onClose={() => {
                setRow(false);
                rowReset();
              }}
              setValue={setRowValue}
              watch={rowWatch}
              register={rowRegister}
              errors={rowErrors}
              clearErrors={rowClearErrors}
              isPending={isCreateRowPending}
              control={rowControl}
              handleSubmit={handleRowSubmit(handleCreateRow)}
              rackInstanceId={""}
              shelveId={currentAreaId}
              warehouseId={""}
              clientId={""}
              fetchShelves={() => {}}
              rowId={""}
            />
          )}

          {rackLevelModal && (
            <CreateRowModal
              open={rackLevelModal}
              hideModeToggle={true}
              onClose={() => {
                setRackLevelModal(false);
                rowReset();
              }}
              setValue={setRowValue}
              watch={rowWatch}
              register={rowRegister}
              errors={rowErrors}
              clearErrors={rowClearErrors}
              isPending={isRowPending}
              control={rowControl}
              handleSubmit={handleRowSubmit(handleCreateRackLevel)}
              rackInstanceId={""}
              shelveId={currentAreaId}
              warehouseId={selectedWarehouseId}
              clientId={selectedWarehouse?.clientId}
              fetchShelves={() => {
                refetchShelveRows();
                refetchFloorList();
              }}
              rowId={selectedRow?.id ?? ""}
              rows={shelveRows}
              floorsByRack={floorsByRack}
              floorsByRow={floorsByRow}
            />
          )}

          {floorModal && (
            <div className="bg-[#F7F6F2] rounded-3xl overflow-hidden shadow-2xl flex flex-col">
              <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
                <div>
                  <h2 className="text-lg font-bold text-[#212121]">
                    <T>Add Floor Storage</T>
                  </h2>
                  <p className="text-xs text-gray-500">
                    {t("Create floor storage in")} {selectedRow?.name}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setFloorModal(false);
                  }}
                  className="p-2 hover:bg-gray-100 rounded-full transition"
                >
                  <IconX size={20} />
                </button>
              </div>
              <CreateFloorModal
                shelveId={currentAreaId}
                fetchShelves={() => {
                  refetchFloorList();
                  refetchShelveRows();
                }}
                rows={shelveRows}
                selectedRow={selectedRow}
                floorsByRack={floorsByRack}
                floorsByRow={floorsByRow}
                onClose={() => {
                  setFloorModal(false);
                }}
              />
            </div>
          )}

          {editRackModalOpen && (
            <EditRackModal
              open={editRackModalOpen}
              inline={true}
              onClose={() => setEditRackModalOpen(false)}
              register={editRackRegister}
              setValue={setEditRackValue}
              control={editRackControl}
              errors={editRackErrors}
              handleSubmit={handleEditRackSubmit(handleEditRack)}
              isPending={isRackUpdatePending}
              defaultValues={editRackDefaultValues}
            />
          )}

          {binModalOpen && (selectedRack || selectedLevelParentRack) && (
            <CreateBinsModal
              open={binModalOpen}
              onClose={() => setBinModalOpen(false)}
              rackLevels={
                (selectedRack || selectedLevelParentRack)?.level || []
              }
              rackInstanceId={(selectedRack || selectedLevelParentRack)?.id}
              warehouseId={selectedWarehouseId}
              clientId={selectedWarehouse?.clientId}
              storageType={
                selectedArea?.storageType === "B2C" ? "Shelves" : "Bins"
              }
              fetchShelves={() => {
                refetchShelveRows();
                refetchFloorList();
              }}
              rowId={selectedRow?.id || selectedLevelParentRow?.id}
              shelveId={""}
              areaId={currentAreaId || ""}
              preselectedLevelId={selectedLevel?.id}
              preselectedType={preselectedType}
            />
          )}

          {palletModalOpen && selectedFloor && (
            <CreatePalletModal
              open={palletModalOpen}
              onClose={() => setPalletModalOpen(false)}
              warehouseId={selectedWarehouseId}
              clientId={selectedWarehouse?.clientId}
              fetchShelves={() => {
                refetchShelveRows();
                refetchFloorList();
              }}
              floorId={selectedFloor.id}
              floorName={selectedFloor.name}
              areaId={currentAreaId}
            />
          )}

          {floorArchiveConfirmModal.open && (
            <MessageModal
              open={floorArchiveConfirmModal.open}
              onClose={() =>
                setFloorArchiveConfirmModal({
                  open: false,
                  floor: null,
                  action: "archive",
                })
              }
              title={
                floorArchiveConfirmModal.action === "archive"
                  ? t("Archive Floor Area?")
                  : t("Reactivate Floor Area?")
              }
              subtitle={
                floorArchiveConfirmModal.action === "archive"
                  ? t("Hide this floor area and its contents from daily operations.")
                  : t("Return this floor area to active daily operations.")
              }
              img={
                floorArchiveConfirmModal.action === "archive"
                  ? "/img/archive.png"
                  : "/img/restore.png"
              }
              showFooter={true}
              actionButtonText={
                floorArchiveConfirmModal.action === "archive"
                  ? t("Confirm Archive")
                  : t("Confirm Restore")
              }
              actionButtonOnClick={() => {
                archiveMutation.mutate(
                  {
                    id: floorArchiveConfirmModal.floor.id,
                    status:
                      floorArchiveConfirmModal.action === "archive"
                        ? "INACTIVE"
                        : "ACTIVE",
                    model: "floor",
                  },
                  {
                    onSuccess: () => {
                      toast.success(
                        floorArchiveConfirmModal.action === "archive"
                          ? t("Floor archived successfully")
                          : t("Floor restored successfully"),
                      );
                      setFloorArchiveConfirmModal({
                        open: false,
                        floor: null,
                        action: "archive",
                      });
                      setSelectedFloor(null);
                      refetchShelveRows();
                      refetchFloorList();
                    },
                    onError: (error: any) => {
                      toast.error(
                        `${t("Failed to")} ${floorArchiveConfirmModal.action} floor: ${error.message}`,
                      );
                    },
                  },
                );
              }}
              isPending={archiveMutation.isPending}
            />
          )}

          {rowArchiveConfirmModal.open && (
            <MessageModal
              open={rowArchiveConfirmModal.open}
              onClose={() =>
                setRowArchiveConfirmModal({
                  open: false,
                  row: null,
                  action: "archive",
                })
              }
              title={
                rowArchiveConfirmModal.action === "archive"
                  ? t("Archive Row?")
                  : t("Reactivate Row?")
              }
              subtitle={
                rowArchiveConfirmModal.action === "archive"
                  ? t("Hide this row and its contents from daily operations.")
                  : t("Return this row to active daily operations.")
              }
              img={
                rowArchiveConfirmModal.action === "archive"
                  ? "/img/archive.png"
                  : "/img/restore.png"
              }
              showFooter={true}
              actionButtonText={
                rowArchiveConfirmModal.action === "archive"
                  ? t("Confirm Archive")
                  : t("Confirm Restore")
              }
              actionButtonOnClick={() => {
                archiveMutation.mutate(
                  {
                    id: rowArchiveConfirmModal.row.id,
                    status:
                      rowArchiveConfirmModal.action === "archive"
                        ? "INACTIVE"
                        : "ACTIVE",
                    model: "row",
                  },
                  {
                    onSuccess: () => {
                      toast.success(
                        rowArchiveConfirmModal.action === "archive"
                          ? t("Row archived successfully")
                          : t("Row restored successfully"),
                      );
                      setRowArchiveConfirmModal({
                        open: false,
                        row: null,
                        action: "archive",
                      });
                      setSelectedRow(null);
                      refetchShelveRows();
                      refetchFloorList();
                    },
                    onError: (error: any) => {
                      toast.error(
                        `${t("Failed to")} ${rowArchiveConfirmModal.action} row: ${error.message}`,
                      );
                    },
                  },
                );
              }}
              isPending={archiveMutation.isPending}
            />
          )}

          {rackArchiveConfirmModal.open && (
            <MessageModal
              open={rackArchiveConfirmModal.open}
              onClose={() =>
                setRackArchiveConfirmModal({
                  open: false,
                  rack: null,
                  action: "archive",
                })
              }
              title={
                rackArchiveConfirmModal.action === "archive"
                  ? t("Archive Rack?")
                  : t("Reactivate Rack?")
              }
              subtitle={
                rackArchiveConfirmModal.action === "archive"
                  ? t("Hide this rack and its contents from daily operations.")
                  : t("Return this rack to active daily operations.")
              }
              img={
                rackArchiveConfirmModal.action === "archive"
                  ? "/img/archive.png"
                  : "/img/restore.png"
              }
              showFooter={true}
              actionButtonText={
                rackArchiveConfirmModal.action === "archive"
                  ? t("Confirm Archive")
                  : t("Confirm Restore")
              }
              actionButtonOnClick={() => {
                archiveMutation.mutate(
                  {
                    id: rackArchiveConfirmModal.rack.id,
                    status:
                      rackArchiveConfirmModal.action === "archive"
                        ? "INACTIVE"
                        : "ACTIVE",
                    model: "rack",
                  },
                  {
                    onSuccess: () => {
                      toast.success(
                        rackArchiveConfirmModal.action === "archive"
                          ? t("Rack archived successfully")
                          : t("Rack restored successfully"),
                      );
                      setRackArchiveConfirmModal({
                        open: false,
                        rack: null,
                        action: "archive",
                      });
                      setSelectedRack(null);
                      refetchShelveRows();
                      refetchFloorList();
                    },
                    onError: (error: any) => {
                      toast.error(
                        `${t("Failed to")} ${rackArchiveConfirmModal.action} rack: ${error.message}`,
                      );
                    },
                  },
                );
              }}
              isPending={archiveMutation.isPending}
            />
          )}

          {levelArchiveConfirmModal.open && (
            <MessageModal
              open={levelArchiveConfirmModal.open}
              onClose={() =>
                setLevelArchiveConfirmModal({
                  open: false,
                  level: null,
                  action: "archive",
                })
              }
              title={
                levelArchiveConfirmModal.action === "archive"
                  ? t("Archive Level?")
                  : t("Reactivate Level?")
              }
              subtitle={
                levelArchiveConfirmModal.action === "archive"
                  ? t("Hide this level and its contents from daily operations.")
                  : t("Return this level to active daily operations.")
              }
              img={
                levelArchiveConfirmModal.action === "archive"
                  ? "/img/archive.png"
                  : "/img/restore.png"
              }
              showFooter={true}
              actionButtonText={
                levelArchiveConfirmModal.action === "archive"
                  ? t("Confirm Archive")
                  : t("Confirm Restore")
              }
              actionButtonOnClick={() => {
                archiveMutation.mutate(
                  {
                    id: levelArchiveConfirmModal.level.id,
                    status:
                      levelArchiveConfirmModal.action === "archive"
                        ? "INACTIVE"
                        : "ACTIVE",
                    model: "level",
                  },
                  {
                    onSuccess: () => {
                      toast.success(
                        levelArchiveConfirmModal.action === "archive"
                          ? t("Level archived successfully")
                          : t("Level restored successfully"),
                      );
                      setLevelArchiveConfirmModal({
                        open: false,
                        level: null,
                        action: "archive",
                      });
                      setSelectedLevel(null);
                      refetchShelveRows();
                      refetchFloorList();
                    },
                    onError: (error: any) => {
                      toast.error(
                        `${t("Failed to")} ${levelArchiveConfirmModal.action} level: ${error.message}`,
                      );
                    },
                  },
                );
              }}
              isPending={archiveMutation.isPending}
            />
          )}

          {editRowNameModal.open && (
            <EditRowNameModal
              open={editRowNameModal.open}
              onClose={() => setEditRowNameModal({ open: false, row: null })}
              onSubmit={(data) => {
                updateRow(
                  {
                    name: data.name,
                  },
                  {
                    onSuccess: () => {
                      toast.success(t("Row name updated successfully"));
                      setEditRowNameModal({ open: false, row: null });
                      refetchShelveRows();
                      refetchFloorList();
                    },
                    onError: (error: any) => {
                      toast.error(
                        `${t("Failed to update row name")}: ${error.message}`,
                      );
                    },
                  },
                );
              }}
              isPending={isRowUpdatePending}
              currentName={editRowNameModal.row?.name || ""}
            />
          )}
        </div>
        )}
      </div>
    );
  };

  const isHeatmap = activeView === "heatmap";

  const headerContent = (
    <>
      <div className="flex items-center space-x-4 overflow-x-auto scrollbar-hide whitespace-nowrap py-1">
        <RoleToggle
          containerClassName="space-x-2 w-[500px] pb-2"
          inactiveClassName="bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors"
          options={
            warehouses?.warehouses?.length > 0
              ? warehouses?.warehouses?.map(
                  (warehouse: any) => warehouse?.name,
                )
              : []
          }
          active={warehouse}
          translateOptions={false}
          onChange={(value) => {
            setWarehouse(value);
            setArea("");
            setShowActions(false);
          }}
          onDoubleClick={(value) => {
            if (!canUpdateShelves) return;
            setWarehouse(value);
            setArea("");
            setShowActions(true);
          }}
        />
      </div>

      <div className="flex items-center flex-wrap gap-2.5">
        {/* Filter Options Select Dropdown */}
        {activeView === "heatmap" && warehouse && warehouse !== "" && area && area !== "" && (
          <div className="relative">
            <select
              id="heatmap-filter-select"
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
              className="h-8 pl-3 pr-8 rounded-md border border-slate-200 bg-white text-xs font-semibold text-slate-700 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-400/20 focus:border-blue-300 transition-all cursor-pointer appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23475569%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:14px] bg-[right_8px_center] bg-no-repeat"
            >
              <option value="All">{t("All Locations")}</option>
              <option value="Active">{t("Active")}</option>
              <option value="Archived">{t("Archived")}</option>
              <option value="Full">{t("Full")}</option>
              <option value="Empty">{t("Empty")}</option>
            </select>
          </div>
        )}
        {/* Heatmap / Inventory Toggle Buttons */}
        <div className="flex items-center gap-1.5 mr-2">
          {["Heatmap", "Inventory"].map((item) => {
            const isActive = (item === "Heatmap" && activeView === "heatmap") || 
                             (item === "Inventory" && activeView === "inventory");
            return (
              <button
                key={item}
                onClick={() => {
                  setActiveView(item === "Heatmap" ? "heatmap" : "inventory");
                  setSearchFor("");
                  setShowSearch(false);
                }}
                className={`text-xs font-semibold h-8 transition-all duration-200 ${
                  isActive
                    ? "rounded-md bg-[#FBD037] px-3 text-[#131327] shadow-sm hover:shadow-md transform hover:scale-[1.02]"
                    : "text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-3 rounded-md border border-slate-200 bg-white"
                }`}
              >
                {t(item)}
                {item === "Heatmap" && isActive && (
                  <span className="ml-1.5 text-[9px] bg-[#131327]/10 text-[#131327]/90 px-1 py-0.5 rounded font-bold">
                    {t("Beta")}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Sliding Search - Only visible when Inventory tab is selected and a warehouse is selected */}
        {activeView === "inventory" && selectedWarehouse && (
          <div
            onClick={() => {
              if (!showSearch) {
                setShowSearch(true);
              }
            }}
            className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${
              showSearch
                ? "w-64 px-2 cursor-default ring-2 ring-blue-400/20 border-blue-300"
                : "w-8 justify-center cursor-pointer hover:border-blue-400 hover:shadow-md"
            }`}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowSearch(!showSearch);
              }}
              className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0 hover:text-blue-600 transition-colors"
              title="Search"
            >
              <IconSearch size={17} stroke={2.5} />
            </button>
            {showSearch && (
              <>
                <input
                  type="text"
                  value={searchFor}
                  onChange={(e) => setSearchFor(e.target.value)}
                  placeholder="Search locations, products..."
                  autoFocus
                  className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      setSearchFor("");
                      setShowSearch(false);
                    }
                  }}
                />
                {searchFor && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSearchFor("");
                    }}
                    className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded focus:outline-none flex-shrink-0 transition-colors"
                  >
                    <IconX size={12} stroke={2.5} />
                  </button>
                )}
              </>
            )}
          </div>
        )}

        {/* Action Buttons with Tooltips */}
        {activeView !== "inventory" && (
          <div className="flex items-center gap-1.5">
            {canCreateProductInventory && warehouse && warehouse !== "" && (
              <button
                onClick={() => setShowShelveSkuModal(true)}
                className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-blue-400 hover:text-blue-600 transition-all duration-200 group relative"
                title="Add New Location"
              >
                <IconPlus stroke={2.5} size={17} />
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-md z-10">
                  Add Location
                  <span className="absolute top-full left-1/2 -translate-x-1/2 w-1.5 h-1.5 rotate-45 bg-slate-800 -mt-0.5"></span>
                </span>
              </button>
            )}
            {canCreateShelves && (
              <button
                onClick={() => setOpenBluk(true)}
                className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-emerald-400 hover:text-emerald-600 transition-all duration-200 group relative"
                title="Bulk Upload"
              >
                <IconCloudUpload stroke={2.5} size={17} />
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-md z-10">
                  Bulk Upload
                  <span className="absolute top-full left-1/2 -translate-x-1/2 w-1.5 h-1.5 rotate-45 bg-slate-800 -mt-0.5"></span>
                </span>
              </button>
            )}
            {warehouse && warehouse !== "" && (
              <button
                onClick={handleDownload}
                className="flex items-center justify-center gap-2 p-1.5 rounded-md border text-slate-700 shadow-sm hover:shadow-md hover:border-purple-400 hover:text-purple-600 transition-all duration-200 group relative"
                title="Export Data"
              >
                <IconDownload stroke={2.5} size={17} />
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-md z-10">
                  Export Data
                  <span className="absolute top-full left-1/2 -translate-x-1/2 w-1.5 h-1.5 rotate-45 bg-slate-800 -mt-0.5"></span>
                </span>
              </button>
            )}
          </div>
        )}

        {/* Enhanced Stats Dashboard */}
        {activeView === "inventory" && warehouse && warehouse !== "" && inventoryActiveTab !== "InventoryCheck" && (inventoryActiveTab !== "ShipmentInventory" || inventoryActiveSubTab === "Inventory") && (
          <div className="flex items-center gap-2 px-3 py-1 bg-gradient-to-r from-blue-50/80 to-indigo-50/80 border border-blue-100 rounded-md shadow-sm select-none hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1.5">
                <span className="text-slate-500 text-[11px] font-medium">
                  Total
                </span>
                <span className="text-blue-700 bg-blue-50 border border-blue-100 px-2 py-0.5 rounded-md text-xs font-bold">
                  {inventoryActiveTab === "ShipmentInventory"
                    ? shipmentTotalCount
                    : receivedCount + reservedCount}
                </span>
              </div>
              {inventoryActiveTab !== "ShipmentInventory" && (
                <>
                  <div className="h-5 w-px bg-blue-200" />
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate-500 text-[11px] font-medium">
                      Received
                    </span>
                    <span className="text-emerald-700 bg-emerald-50 border border-emerald-100 px-2 py-0.5 rounded-md text-xs font-bold">
                      {receivedCount}
                    </span>
                  </div>
                  <div className="h-5 w-px bg-blue-200" />
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate-500 text-[11px] font-medium">
                      Reserved
                    </span>
                    <span className="text-amber-700 bg-amber-50 border border-amber-100 px-2 py-0.5 rounded-md text-xs font-bold">
                      {reservedCount}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );

  const shouldMerge = true;

  return (
    <div className="grid grid-cols-12 gap-6 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-r-3xl rounded-bl-3xl w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <div className="col-span-12">
        <div className="bg-white rounded-3xl overflow-visible flex flex-col">
          {/* Header Section - Merged */}
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 p-4 border-b border-slate-100 rounded-t-3xl bg-gradient-to-r from-white to-slate-50/50">
            {headerContent}
          </div>
          {/* Main Content - Merged */}
          {renderContent(true)}
        </div>
      </div>

      {/* Add CSS for animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideDown {
          animation: slideDown 0.25s ease-out;
        }
        .scrollbar-thin::-webkit-scrollbar {
          width: 4px;
          height: 4px;
        }
        .scrollbar-thin::-webkit-scrollbar-track {
          background: transparent;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 9999px;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      {/* Modals that need to be outside the conditional render */}
      {openbluk && (
        <ShelveBulkUploadModals
          onClose={() => setOpenBluk(false)}
          onResponseOpene={() => setOpenResponse(true)}
          warehouseId={selectedWarehouseId}
        />
      )}

      {locationArchiveConfirmModal.open && (
        <MessageModal
          open={locationArchiveConfirmModal.open}
          onClose={() =>
            setLocationArchiveConfirmModal({
              open: false,
              item: null,
              type: "bin",
              action: "archive",
            })
          }
          title={
            locationArchiveConfirmModal.action === "archive"
              ? `Archive ${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"}?`
              : `Reactivate ${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"}?`
          }
          subtitle={
            locationArchiveConfirmModal.action === "archive"
              ? `Hide this ${locationArchiveConfirmModal.type === "bin" ? "bin" : "pallet"} and its contents from daily operations.`
              : `Return this ${locationArchiveConfirmModal.type === "bin" ? "bin" : "pallet"} to active daily operations.`
          }
          img={
            locationArchiveConfirmModal.action === "archive"
              ? "/img/archive.png"
              : "/img/restore.png"
          }
          showFooter={true}
          actionButtonText={
            locationArchiveConfirmModal.action === "archive"
              ? "Confirm Archive"
              : "Confirm Restore"
          }
          actionButtonOnClick={() => {
            archiveMutation.mutate(
              {
                id: locationArchiveConfirmModal.item.id,
                status:
                  locationArchiveConfirmModal.action === "archive"
                    ? "INACTIVE"
                    : "ACTIVE",
                model: locationArchiveConfirmModal.type,
              },
              {
                onSuccess: () => {
                  toast.success(
                    locationArchiveConfirmModal.action === "archive"
                      ? `${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"} archived successfully`
                      : `${locationArchiveConfirmModal.type === "bin" ? "Bin" : "Pallet"} restored successfully`,
                  );
                  setLocationArchiveConfirmModal({
                    open: false,
                    item: null,
                    type: "bin",
                    action: "archive",
                  });
                  setSelectedLocation(null);
                  refetchShelveRows();
                  refetchFloorList();
                },
                onError: (error: any) => {
                  toast.error(
                    `Failed to ${locationArchiveConfirmModal.action} ${locationArchiveConfirmModal.type}: ${error.message}`,
                  );
                },
              },
            );
          }}
          isPending={archiveMutation.isPending}
        />
      )}
    </div>
  );
}